import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.harnesses.item');
import { OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-harnesses-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.harnesses.item/view.scss */
.ops-page {
  --ops-ink: #25221f;
  --ops-muted: #77736c;
  --ops-line: #ddd9d1;
  --ops-line-soft: #ece9e3;
  --ops-soft: #f6f7f3;
  --ops-olive: #30491f;
  --ops-green: #52732e;
  --ops-orange: #b8521b;
  --ops-canvas: var(--ro-canvas, #fafbf8);
  min-height: 100%;
  color: var(--ops-ink);
  background: var(--ops-canvas);
}

.ops-page *,
.ops-page *::before,
.ops-page *::after,
.ops-modal-backdrop *,
.ops-modal-backdrop *::before,
.ops-modal-backdrop *::after {
  box-sizing: border-box;
}

.ops-page button,
.ops-page input,
.ops-page select,
.ops-page textarea,
.ops-modal-backdrop button,
.ops-modal-backdrop input,
.ops-modal-backdrop select,
.ops-modal-backdrop textarea {
  font: inherit;
}

.ops-shell {
  width: min(100%, 1500px);
  margin: 0 auto;
  padding-right: 32px;
  padding-left: 32px;
}

.ops-header {
  position: relative;
  z-index: 2;
  border-bottom: 1px solid #d8d5ce;
  background: #fff;
  box-shadow: 0 1px 0 rgba(42, 40, 35, 0.025);
}

.ops-header__inner {
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 26px;
}

.ops-heading {
  min-width: 0;
  animation: ops-fade-up 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #817d75;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.ops-eyebrow i,
.ops-result-meta > div i {
  width: 3px;
  height: 3px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #c5c0b8;
}

.ops-eyebrow strong {
  color: var(--ops-orange);
  font-weight: 900;
}

.ops-heading h1 {
  margin: 7px 0 0;
  color: #1f1d1a;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: -0.035em;
}

.ops-heading > p {
  margin: 7px 0 0;
  color: #706c65;
  font-size: 13px;
  line-height: 1.45;
}

.ops-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  animation: ops-fade-up 500ms 70ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-header-status {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #d9d7d0;
  border-radius: 10px;
  background: #fafaf8;
  color: #5f6f50;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-header-status i {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #587b34;
}

.ops-header-status i::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(88, 123, 52, 0.26);
  border-radius: inherit;
  content: "";
  animation: ops-live 2.4s ease-out infinite;
}

.ops-primary-button {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 17px;
  border: 0;
  border-radius: 10px;
  background: var(--ops-olive);
  color: #fff;
  box-shadow: 0 8px 20px rgba(48, 73, 31, 0.17);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
  transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.ops-primary-button svg {
  width: 16px;
  height: 16px;
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-primary-button:hover {
  background: #3d592a;
  box-shadow: 0 11px 24px rgba(48, 73, 31, 0.22);
  transform: translateY(-1px);
}

.ops-primary-button:hover svg {
  transform: rotate(90deg);
}

.ops-primary-button:active {
  transform: translateY(0) scale(0.98);
}

.ops-content {
  display: grid;
  gap: 22px;
  padding-top: 24px;
  padding-bottom: 32px;
}

.ops-summary,
.ops-panel {
  overflow: hidden;
  border: 1px solid #d9d6cf;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 13px 32px rgba(42, 40, 35, 0.06), 0 2px 5px rgba(42, 40, 35, 0.03);
}

.ops-summary {
  min-height: 82px;
  display: grid;
  grid-template-columns: 245px minmax(0, 1fr);
  background: linear-gradient(105deg, #fff 0%, #fbfbf8 100%);
  animation: ops-panel-in 540ms 100ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-summary__intro {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
}

.ops-summary__icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 11px;
  background: #edf2e8;
  color: #47672d;
}

.ops-summary__icon svg {
  width: 20px;
  height: 20px;
}

.ops-summary__intro strong {
  display: block;
  color: #34312d;
  font-size: 13px;
  font-weight: 900;
}

.ops-summary__intro p {
  margin: 5px 0 0;
  color: #8b877f;
  font-size: 10px;
  white-space: nowrap;
}

.ops-summary__grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ops-stat {
  --stat-color: #8a9ab0;
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
  animation: ops-stat-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-stat:nth-child(1) {
  animation-delay: 170ms;
}

.ops-stat:nth-child(2) {
  animation-delay: 220ms;
}

.ops-stat:nth-child(3) {
  animation-delay: 270ms;
}

.ops-stat:nth-child(4) {
  animation-delay: 320ms;
}

.ops-stat:last-child {
  border-right: 0;
}

.ops-stat::before {
  position: absolute;
  top: 20px;
  right: 18px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--stat-color);
  content: "";
}

.ops-stat > span {
  color: #77736c;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-stat > div {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.ops-stat strong {
  color: #292622;
  font-size: 25px;
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.04em;
}

.ops-stat small {
  color: #aaa69f;
  font-size: 10px;
}

.ops-stat--neutral {
  --stat-color: #8a9ab0;
}

.ops-stat--green {
  --stat-color: #52732e;
}

.ops-stat--violet {
  --stat-color: #70578e;
}

.ops-stat--amber {
  --stat-color: #c77813;
}

.ops-panel {
  animation: ops-panel-in 540ms 170ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-toolbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.ops-tabs {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border-radius: 10px;
  background: #eff1ed;
}

.ops-tab {
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #716e67;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  transition: color 170ms ease, background 170ms ease, box-shadow 170ms ease, transform 170ms ease;
}

.ops-tab em {
  min-width: 19px;
  height: 19px;
  display: inline-grid;
  place-items: center;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(87, 83, 75, 0.08);
  color: #8a867f;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.ops-tab:hover {
  color: #34312d;
}

.ops-tab.is-active {
  background: #fff;
  color: #2f4024;
  box-shadow: 0 2px 8px rgba(45, 51, 40, 0.1), inset 0 0 0 1px rgba(62, 82, 45, 0.08);
  transform: translateY(-1px);
}

.ops-tab.is-active em {
  background: #e7eee0;
  color: #47632f;
}

.ops-filter-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-search,
.ops-select {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #d6d3cc;
  border-radius: 9px;
  background: #fff;
  color: #858078;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-search {
  width: 265px;
  padding-left: 12px;
}

.ops-select {
  width: 145px;
  padding-left: 11px;
}

.ops-search:focus-within,
.ops-select:focus-within {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-search > svg,
.ops-select > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.ops-search input,
.ops-select select {
  width: 100%;
  height: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #403d38;
  font-size: 12px;
}

.ops-search input {
  padding: 0 34px 0 10px;
}

.ops-select select {
  padding: 0 9px;
}

.ops-search input::placeholder {
  color: #a39f97;
}

.ops-search > button {
  position: absolute;
  right: 7px;
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #f0f1ed;
  color: #77736c;
  cursor: pointer;
  font-size: 14px;
}

.ops-check {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #625f59;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.ops-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.ops-check > span {
  width: 34px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #d8d9d4;
  transition: background 180ms ease;
}

.ops-check > span i {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(25, 27, 23, 0.18);
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-check input:checked + span {
  background: #547535;
}

.ops-check input:checked + span i {
  transform: translateX(14px);
}

.ops-check strong {
  font-weight: 750;
}

.ops-result-meta {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--ops-line-soft);
  background: #fcfcfa;
}

.ops-result-meta > div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7f7b74;
  font-size: 11px;
}

.ops-result-meta > div strong {
  color: var(--ops-orange);
  font-size: 14px;
  font-weight: 900;
}

.ops-reset-button {
  padding: 6px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6e6a63;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: color 160ms ease, background 160ms ease;
}

.ops-reset-button:hover {
  background: #eef0ea;
  color: #40572f;
}

.ops-table-wrap {
  width: 100%;
  overflow: hidden;
}

.ops-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.ops-table thead {
  background: #f5f6f2;
}

.ops-table th {
  height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #ddd9d2;
  color: #6f6b64;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.ops-table th:first-child,
.ops-table td:first-child {
  padding-left: 18px;
}

.ops-table th:last-child,
.ops-table td:last-child {
  padding-right: 18px;
}

.ops-table th.is-number,
.ops-table td.is-number {
  text-align: right;
}

.ops-table td {
  height: 66px;
  padding: 0 12px;
  border-bottom: 1px solid #ece9e3;
  color: #4f4b45;
  font-size: 13px;
  vertical-align: middle;
}

.ops-table tbody:last-child tr:last-child td,
.ops-table tbody > tr:last-child td {
  border-bottom: 0;
}

.ops-row {
  animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 170ms ease, box-shadow 170ms ease;
}

.ops-row:hover {
  background: #fafbf8;
  box-shadow: inset 3px 0 0 #688649;
}

.ops-identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.ops-identity > div {
  min-width: 0;
}

.ops-identity > div > strong {
  display: block;
  overflow: hidden;
  color: #302d29;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-identity > div > p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #8f8b84;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-mark,
.ops-avatar {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.ops-mark--survey {
  border: 1px solid #d7e4cd;
  background: #eef4e9;
  color: #527136;
}

.ops-mark--harness {
  border: 1px solid #ded7e7;
  background: #f2eff6;
  color: #67547e;
}

.ops-avatar {
  border-radius: 12px;
  background: linear-gradient(145deg, #3d552a, #2d411f);
  color: #fff;
  box-shadow: 0 5px 12px rgba(48, 73, 31, 0.16);
  font-size: 12px;
}

.ops-row:hover .ops-mark,
.ops-row:hover .ops-avatar {
  box-shadow: 0 6px 13px rgba(49, 57, 43, 0.11);
  transform: translateY(-1px);
}

.ops-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid var(--status-line);
  border-radius: 999px;
  background: var(--status-bg);
  color: var(--status-color);
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
}

.ops-status i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.status-live {
  --status-bg: #eef5e8;
  --status-color: #4c6e2f;
  --status-line: #d2e1c5;
}

.status-draft {
  --status-bg: #f1f1ee;
  --status-color: #69655e;
  --status-line: #ddd9d2;
}

.status-experiment {
  --status-bg: #f3eef8;
  --status-color: #6c5189;
  --status-line: #ded1e9;
}

.ops-version {
  display: inline-flex;
  padding: 5px 8px;
  border: 1px solid #edd7c6;
  border-radius: 7px;
  background: #fff5ed;
  color: #a4501d;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 900;
}

.ops-number {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.ops-number--strong {
  color: #383530;
  font-weight: 900;
}

.ops-owner {
  color: #58544e;
  font-size: 12px;
  font-weight: 800;
}

.ops-date {
  color: #7f7b74;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.ops-row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #625e58;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.ops-row-action svg {
  width: 14px;
  height: 14px;
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-row-action.is-open svg {
  transform: rotate(180deg);
}

.ops-row-action:hover {
  background: #eef1e9;
  color: #40582f;
}

.ops-row-action--button {
  border: 1px solid #d7d4cd;
  background: #fff;
}

.ops-history-row td {
  height: auto;
  padding: 14px 18px 18px !important;
  background: #f7f8f4;
}

.ops-inline-history {
  overflow: hidden;
  border: 1px solid #dcd9d2;
  border-radius: 10px;
  background: #fff;
  animation: ops-history-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.survey-history-grid {
  display: grid;
  grid-template-columns: 90px 120px 110px minmax(220px, 1fr) 70px;
  align-items: center;
  gap: 10px;
}

.ops-inline-history__head {
  min-height: 35px;
  padding: 0 14px;
  border-bottom: 1px solid #e5e2dc;
  background: #f6f6f3;
  color: #817d76;
  font-size: 10px;
  font-weight: 850;
}

.ops-inline-history__item {
  min-height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #eeece7;
  color: #615d56;
  font-size: 12px;
  animation: ops-row-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-inline-history__item:last-child {
  border-bottom: 0;
}

.ops-inline-history__item strong {
  color: #5c5851;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.ops-inline-history__item strong.is-active {
  color: var(--ops-orange);
}

.ops-inline-history__item p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-inline-history__item .is-number {
  text-align: right;
}

.ops-progress {
  display: flex;
  align-items: center;
  gap: 9px;
}

.ops-progress > div,
.ops-progress-track {
  height: 7px;
  flex: 1;
  overflow: hidden;
  border-radius: 999px;
  background: #e9ebe6;
}

.ops-progress i,
.ops-progress-track i {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: #658747;
  transform-origin: left center;
  animation: ops-progress-in 760ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-progress i.is-warning,
.ops-progress-track i.is-warning {
  background: #bf781a;
}

.ops-progress i.is-complete,
.ops-progress-track i.is-complete {
  background: #4e7950;
}

.ops-progress strong {
  width: 43px;
  flex: 0 0 auto;
  color: #4f4b45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 850;
  text-align: right;
}

.ops-delta {
  color: #477442;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 900;
}

.ops-delta.is-negative {
  color: #b24b38;
}

.ops-field {
  display: grid;
  gap: 4px;
}

.ops-field strong {
  color: #4b4741;
  font-size: 12px;
  font-weight: 900;
}

.ops-field span {
  color: #918d85;
  font-size: 11px;
}

.ops-rating {
  color: #4b6537;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 900;
}

.ops-due {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 850;
}

.ops-due.is-warning {
  color: #b06410;
}

.ops-toggle {
  position: relative;
  width: 40px;
  height: 23px;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: #d4d6d0;
  cursor: pointer;
  transition: background 180ms ease, box-shadow 180ms ease;
}

.ops-toggle > span {
  width: 17px;
  height: 17px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(28, 31, 25, 0.22);
  transition: transform 230ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-toggle.is-active {
  background: #547536;
  box-shadow: 0 0 0 3px rgba(84, 117, 54, 0.1);
}

.ops-toggle.is-active > span {
  transform: translateX(17px);
}

.ops-mobile-list {
  display: none;
}

.ops-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  animation: ops-fade-up 380ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-empty strong {
  font-size: 14px;
}

.ops-empty p {
  margin: 7px 0 0;
  color: #827e77;
  font-size: 12px;
}

.ops-empty button {
  margin-top: 14px;
  padding: 8px 12px;
  border: 1px solid #d6d3cc;
  border-radius: 8px;
  background: #fff;
  color: #425a31;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}

.ops-footer {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid var(--ops-line);
  background: #fbfbf9;
  color: #807c75;
  font-size: 11px;
}

.ops-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(27, 28, 24, 0.52);
  backdrop-filter: blur(5px);
  animation: ops-backdrop-in 220ms ease-out both;
}

.ops-modal {
  width: min(100%, 530px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(22, 24, 20, 0.28);
  animation: ops-modal-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-modal--wide {
  width: min(100%, 760px);
}

.ops-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 19px;
  border-bottom: 1px solid var(--ops-line);
  background: linear-gradient(120deg, #fff 0%, #f7f9f4 100%);
}

.ops-modal__header p {
  margin: 0;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.ops-modal__header h2 {
  margin: 6px 0 0;
  color: #282521;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.ops-modal__header span {
  display: block;
  margin-top: 6px;
  color: #7f7b74;
  font-size: 12px;
}

.ops-modal__header > button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: #eef1ea;
  color: #66625b;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;
}

.ops-modal__header > button:hover {
  background: #e3e8dc;
  color: #354828;
  transform: rotate(5deg);
}

.ops-modal__body {
  display: grid;
  gap: 17px;
  padding: 22px 24px;
}

.ops-modal__body--scroll {
  max-height: 62vh;
  overflow-y: auto;
}

.ops-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.ops-form-field {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.ops-form-field > span {
  color: #4e4a44;
  font-size: 12px;
  font-weight: 850;
}

.ops-form-field input,
.ops-form-field select,
.ops-form-field textarea {
  width: 100%;
  padding: 0 13px;
  border: 1px solid #d5d2cb;
  border-radius: 9px;
  outline: 0;
  background: #fff;
  color: #37342f;
  font-size: 13px;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-form-field input,
.ops-form-field select {
  height: 43px;
}

.ops-form-field textarea {
  min-height: 90px;
  padding-top: 11px;
  padding-bottom: 11px;
  resize: vertical;
}

.ops-form-field input:focus,
.ops-form-field select:focus,
.ops-form-field textarea:focus {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-form-field input::placeholder,
.ops-form-field textarea::placeholder {
  color: #aaa69e;
}

.ops-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--ops-line);
  background: #f8f8f5;
}

.ops-modal__footer button {
  height: 40px;
  padding: 0 15px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.ops-modal-cancel {
  border: 1px solid #d5d2cb;
  background: #fff;
  color: #625e58;
}

.ops-modal-submit {
  border: 1px solid var(--ops-olive);
  background: var(--ops-olive);
  color: #fff;
}

.ops-modal-submit:hover {
  background: #3d592a;
  box-shadow: 0 7px 15px rgba(48, 73, 31, 0.17);
  transform: translateY(-1px);
}

.ops-timeline {
  position: relative;
  display: grid;
  gap: 0;
  padding-left: 25px;
}

.ops-timeline::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 5px;
  width: 1px;
  background: #d9d6cf;
  content: "";
}

.ops-timeline__item {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  padding: 0 0 22px;
  animation: ops-row-in 400ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-timeline__item:last-child {
  padding-bottom: 0;
}

.ops-timeline__item > i {
  position: absolute;
  top: 5px;
  left: -24px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #b9b6af;
  box-shadow: 0 0 0 4px #fff;
}

.ops-timeline__item > i.is-active {
  background: var(--ops-orange);
}

.ops-timeline__content > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-timeline__content > div strong {
  color: #3d3934;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 900;
}

.ops-timeline__content > div span {
  padding: 3px 7px;
  border-radius: 999px;
  background: #fff0e5;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 850;
}

.ops-timeline__content h3 {
  margin: 7px 0 0;
  color: #45413b;
  font-size: 13px;
  font-weight: 800;
}

.ops-timeline__content p {
  margin: 6px 0 0;
  color: #8b877f;
  font-size: 11px;
}

.ops-timeline__metrics {
  display: flex;
  gap: 8px;
}

.ops-timeline__metrics > span {
  min-width: 74px;
  display: grid;
  gap: 4px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #f4f6f1;
  text-align: center;
}

.ops-timeline__metrics small {
  color: #818079;
  font-size: 10px;
}

.ops-timeline__metrics strong {
  color: #456332;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

@media (max-width: 1279px) {
  .ops-table-wrap {
    display: none;
  }
  .ops-mobile-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 14px;
    background: #f7f7f4;
  }
  .ops-mobile-card {
    min-width: 0;
    padding: 15px;
    border: 1px solid #ddd9d2;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(42, 40, 35, 0.035);
    animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: border-color 170ms ease, box-shadow 170ms ease, transform 170ms ease;
  }
  .ops-mobile-card:hover {
    border-color: #b8c3ad;
    box-shadow: 0 8px 19px rgba(45, 57, 36, 0.08);
    transform: translateY(-1px);
  }
  .ops-mobile-card__top,
  .expert-mobile-head,
  .expert-mobile-field,
  .ops-mobile-progress > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-card__top {
    align-items: flex-start;
  }
  .ops-mobile-card__title {
    margin-top: 13px;
  }
  .ops-mobile-card__title > strong {
    display: block;
    overflow: hidden;
    color: #302d29;
    font-size: 15px;
    font-weight: 900;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-card__title > p {
    margin: 5px 0 0;
    color: #8f8b84;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    border-top: 1px solid #ebe8e2;
    border-left: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics > div {
    min-width: 0;
    display: grid;
    gap: 5px;
    padding: 10px;
    border-right: 1px solid #ebe8e2;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics span,
  .expert-mobile-field span,
  .ops-mobile-progress span {
    color: #858179;
    font-size: 11px;
  }
  .ops-mobile-metrics strong,
  .expert-mobile-field strong {
    overflow: hidden;
    color: #44403a;
    font-size: 12px;
    font-weight: 850;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-progress {
    display: grid;
    gap: 8px;
    margin-top: 14px;
  }
  .ops-mobile-progress strong {
    color: #4e4a44;
    font-size: 12px;
  }
  .ops-mobile-history-button {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    padding: 0 11px;
    border: 1px solid #d8d5ce;
    border-radius: 8px;
    background: #fafaf8;
    color: #535e49;
    cursor: pointer;
    font-size: 11px;
    font-weight: 850;
  }
  .ops-mobile-history-button svg {
    width: 15px;
    height: 15px;
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
  }
  .ops-mobile-history-button svg.is-open {
    transform: rotate(180deg);
  }
  .ops-mobile-history {
    display: grid;
    gap: 0;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #dfdcd5;
    border-radius: 9px;
    animation: ops-history-in 340ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  .ops-mobile-history__item {
    padding: 10px 11px;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-history__item:last-child {
    border-bottom: 0;
  }
  .ops-mobile-history__item > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-history__item strong {
    color: #55514b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-history__item strong.is-active {
    color: var(--ops-orange);
  }
  .ops-mobile-history__item span,
  .ops-mobile-history__item p {
    color: #89857d;
    font-size: 10px;
  }
  .ops-mobile-history__item p {
    margin: 6px 0 0;
  }
  .expert-mobile-head .ops-identity {
    min-width: 0;
  }
  .expert-mobile-field {
    margin-top: 14px;
    padding: 10px 11px;
    border-radius: 8px;
    background: #f4f6f1;
  }
}
@media (max-width: 960px) {
  .ops-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .ops-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }
  .ops-tabs::-webkit-scrollbar {
    display: none;
  }
  .ops-search {
    width: 100%;
  }
  .ops-filter-group {
    width: 100%;
  }
  .ops-filter-group .ops-search {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .ops-shell {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ops-header__inner {
    height: auto;
    min-height: 132px;
    align-items: flex-end;
    padding-top: 18px;
    padding-bottom: 17px;
  }
  .ops-heading {
    flex: 1;
  }
  .ops-eyebrow {
    font-size: 9px;
  }
  .ops-heading h1 {
    font-size: 21px;
  }
  .ops-heading > p {
    max-width: 245px;
    font-size: 11px;
  }
  .ops-header-status {
    display: none;
  }
  .ops-primary-button {
    width: 41px;
    padding: 0;
  }
  .ops-primary-button > span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .ops-content {
    gap: 14px;
    padding-top: 14px;
    padding-bottom: 18px;
  }
  .ops-summary,
  .ops-panel {
    border-radius: 13px;
  }
  .ops-summary {
    display: block;
  }
  .ops-summary__intro {
    min-height: 68px;
    padding: 0 14px;
    border-right: 0;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ops-stat {
    min-height: 68px;
    padding: 0 14px;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-stat:nth-child(even) {
    border-right: 0;
  }
  .ops-stat:nth-child(3),
  .ops-stat:nth-child(4) {
    border-bottom: 0;
  }
  .ops-stat strong {
    font-size: 21px;
  }
  .ops-stat > span {
    font-size: 10px;
  }
  .ops-toolbar {
    padding: 12px;
  }
  .ops-tabs {
    width: 100%;
  }
  .ops-tab {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    font-size: 10px;
  }
  .ops-tabs--wide .ops-tab em {
    display: none;
  }
  .ops-toolbar--experts .ops-filter-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 128px;
  }
  .ops-select {
    width: 100%;
  }
  .ops-check {
    align-self: flex-start;
  }
  .ops-result-meta {
    min-height: 48px;
    padding: 6px 12px;
  }
  .ops-mobile-list {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .ops-mobile-card {
    padding: 14px;
  }
  .ops-footer {
    padding: 0 12px;
  }
  .ops-footer span:last-child {
    display: none;
  }
  .ops-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .ops-modal,
  .ops-modal--wide {
    width: 100%;
    max-height: 92vh;
    overflow-y: auto;
    border-radius: 19px 19px 0 0;
    animation-name: ops-sheet-in;
  }
  .ops-modal__header,
  .ops-modal__body,
  .ops-modal__footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .ops-form-grid {
    grid-template-columns: 1fr;
  }
  .ops-timeline__item {
    grid-template-columns: 1fr;
  }
  .ops-timeline__metrics {
    justify-content: flex-start;
  }
}
@media (max-width: 420px) {
  .ops-header__inner {
    gap: 12px;
  }
  .ops-heading > p {
    max-width: 255px;
  }
  .ops-toolbar--experts .ops-filter-group {
    grid-template-columns: 1fr;
  }
}
@keyframes ops-fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px);
    box-shadow: 0 2px 5px rgba(42, 40, 35, 0);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-stat-in {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ops-row-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-progress-in {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes ops-history-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-live {
  0% {
    opacity: 0.9;
    transform: scale(0.7);
  }
  65%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@keyframes ops-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ops-modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes ops-sheet-in {
  from {
    opacity: 0;
    transform: translateY(35px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ops-heading,
  .ops-header__actions,
  .ops-summary,
  .ops-panel,
  .ops-stat,
  .ops-row,
  .ops-mobile-card,
  .ops-empty,
  .ops-inline-history,
  .ops-inline-history__item,
  .ops-mobile-history,
  .ops-progress i,
  .ops-progress-track i,
  .ops-header-status i::after,
  .ops-modal-backdrop,
  .ops-modal,
  .ops-timeline__item {
    animation: none !important;
  }
  .ops-primary-button,
  .ops-primary-button svg,
  .ops-row,
  .ops-mobile-card,
  .ops-mark,
  .ops-avatar,
  .ops-toggle,
  .ops-toggle > span,
  .ops-row-action svg,
  .ops-mobile-history-button svg {
    transition: none !important;
  }
}
:host {
  display: block;
  height: 100%;
}

.harness-detail-page {
  --hd-ink: #202124;
  --hd-muted: #74767c;
  --hd-line: #dfe1e5;
  --hd-orange: #e4572e;
  --hd-green: #3f7d3a;
  --hd-amber: #d88708;
  --hd-blue: #5067bd;
  min-height: 100%;
  overflow-x: hidden;
  color: var(--hd-ink);
  background: #f7f8f4;
}

.harness-detail-page *,
.harness-detail-page *::before,
.harness-detail-page *::after {
  box-sizing: border-box;
}

.harness-detail-page button {
  font: inherit;
}

.harness-detail-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border: 0;
  background: #fff;
  box-shadow: inset 0 -1px 0 #dfe1e5, 0 6px 18px rgba(32, 33, 36, 0.03);
}

.harness-detail-header__inner {
  min-height: 124.444px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding-block: 22px;
}

.harness-detail-title-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 15px;
}

.harness-detail-back {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid #d9dce0;
  background: #fff;
  color: #51545a;
  cursor: pointer;
}

.harness-detail-back:hover {
  border-color: #aeb2b9;
  background: #f6f6f6;
}

.harness-detail-title-group > div {
  min-width: 0;
}

.harness-detail-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7c7f85;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.harness-detail-eyebrow em {
  color: #b5b7bb;
  font-style: normal;
}

.harness-detail-eyebrow strong {
  color: var(--hd-orange);
  font-weight: 700;
}

.harness-detail-title-group h1 {
  margin: 6px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-detail-title-group p {
  margin: 7px 0 0;
  color: #71747a;
  font-size: 12px;
}

.harness-detail-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.harness-detail-status,
.harness-detail-version {
  height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border-radius: 4px;
  background: #f0f1f2;
  color: #5f6268;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-status i {
  font-size: 12px;
}

.harness-detail-status.is-ready {
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-detail-status.is-review {
  background: #fff2df;
  color: #b96e00;
}

.harness-detail-status.is-draft {
  background: #edf0fb;
  color: var(--hd-blue);
}

.harness-detail-version {
  background: #fff0e9;
  color: #d34d25;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.harness-detail-readonly {
  height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #d3dfd4;
  border-radius: 4px;
  background: #edf4eb;
  color: #526e57;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.harness-detail-header__actions button {
  height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  border: 0;
  background: #2e3035;
  color: #fff;
  cursor: pointer;
}

.harness-detail-header__actions button:hover {
  background: #1f2023;
}

.harness-detail-header__actions button.harness-detail-download {
  color: #3f5f56;
  background: #fff;
  border: 1px solid #cad5d0;
}

.harness-detail-header__actions button.harness-detail-download:hover,
.harness-detail-header__actions button.harness-detail-download:focus-visible {
  color: #fff;
  background: #3f6f62;
  border-color: #3f6f62;
  outline: 0;
}

.harness-detail-content {
  display: grid;
  gap: 18px;
  padding-block: 22px 34px;
}

.harness-readonly-content {
  display: grid;
  gap: 18px;
}

.harness-readonly-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.harness-readonly-summary article {
  min-height: 118px;
  display: grid;
  align-content: center;
  gap: 16px;
  padding: 22px 24px;
  border: 1px solid #dfe4df;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(42, 51, 44, 0.04);
}

.harness-readonly-summary article > span {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #78827a;
  font-size: 12px;
  font-weight: 700;
}

.harness-readonly-summary article > span i {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: #edf3ec;
  color: #58705d;
}

.harness-readonly-summary article > strong {
  color: #283129;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.harness-readonly-summary__score > strong {
  color: #c45231 !important;
}

.harness-readonly-summary__projects > strong {
  color: #4d7054 !important;
}

.harness-readonly-rules {
  overflow: hidden;
  border: 1px solid #dfe4df;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(42, 51, 44, 0.04);
}

.harness-readonly-rules > header {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 24px;
  border-bottom: 1px solid #e5e9e5;
  background: #f8faf7;
}

.harness-readonly-rules > header span {
  color: #df5c39;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.harness-readonly-rules > header h2 {
  margin: 5px 0 0;
  color: #2d372f;
  font-size: 18px;
  letter-spacing: -0.03em;
}

.harness-readonly-rules > header em {
  min-width: 42px;
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #eaf2e8;
  color: #55705a;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-readonly-rules ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

.harness-readonly-rules li {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 13px;
  align-items: start;
  padding: 17px 24px;
  border-bottom: 1px solid #edf0ed;
}

.harness-readonly-rules li:last-child {
  border-bottom: 0;
}

.harness-readonly-rules li b {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: #edf3ec;
  color: #5e795f;
  font-size: 12px;
}

.harness-readonly-rules li p {
  margin: 3px 0 0;
  color: #455149;
  font-size: 12px;
  line-height: 1.65;
}

.harness-readonly-rules__empty {
  min-height: 160px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  color: #89928b;
}

.harness-readonly-rules__empty i {
  font-size: 24px;
}

.harness-readonly-rules__empty strong {
  font-size: 12px;
}

.harness-detail-tabs {
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 5px;
  border: 1px solid var(--hd-line);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(32, 33, 36, 0.035);
}

.harness-detail-tabs button {
  min-width: 120px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: #6c6f75;
  cursor: pointer;
}

.harness-detail-tabs button:hover {
  background: #f4f5f6;
  color: #33353a;
}

.harness-detail-tabs button.is-active {
  background: #2f3135;
  color: #fff;
}

.harness-detail-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--hd-line);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 33, 36, 0.04);
}

.harness-detail-summary article {
  min-height: 88px;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 16px 20px;
  border-right: 1px solid #e5e7ea;
  border-radius: 0;
  box-shadow: none;
}

.harness-detail-summary article:last-child {
  border-right: 0;
}

.harness-detail-summary article > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 5px;
  background: #f0f1f2;
  color: #666a71;
  font-size: 14px;
}

.harness-detail-summary article:nth-child(1) > i {
  color: var(--hd-amber);
}

.harness-detail-summary article:nth-child(2) > i {
  color: var(--hd-blue);
}

.harness-detail-summary article:nth-child(3) > i {
  color: var(--hd-green);
}

.harness-detail-summary article:nth-child(4) > i {
  color: #68499a;
}

.harness-detail-summary article > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.harness-detail-summary span {
  color: #7e8187;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-summary strong {
  overflow: hidden;
  color: #25272b;
  font-size: 17px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-detail-summary small {
  color: #9a9da3;
  font-size: 12px;
}

.harness-detail-overview {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 18px;
}

.harness-detail-primary,
.harness-detail-side {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 18px;
}

.harness-detail-card {
  overflow: hidden;
  border: 1px solid var(--hd-line);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 33, 36, 0.04);
}

.harness-detail-card > header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7ea;
  border-radius: 0;
  box-shadow: none;
}

.harness-detail-card > header span,
.harness-detail-recommendation header span {
  color: var(--hd-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.harness-detail-card > header h2,
.harness-detail-recommendation h2 {
  margin: 4px 0 0;
  color: #27292e;
  font-size: 15px;
  font-weight: 700;
}

.harness-detail-card > header small {
  color: #8b8e94;
  font-size: 12px;
}

.harness-detail-readiness ol {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.harness-detail-readiness li {
  min-width: 0;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 10px;
  padding: 20px 16px;
  border-right: 1px solid #e7e9ec;
  border-radius: 0;
  box-shadow: none;
}

.harness-detail-readiness li:last-child {
  border-right: 0;
}

.harness-detail-readiness li > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #eceef0;
  color: #96999f;
  font-size: 12px;
}

.harness-detail-readiness li.is-done > span {
  background: #eaf3e6;
  color: var(--hd-green);
}

.harness-detail-readiness li.is-current > span {
  background: #fff0e5;
  color: var(--hd-orange);
}

.harness-detail-readiness li > div {
  min-width: 0;
}

.harness-detail-readiness li strong {
  color: #34363b;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-readiness li p {
  margin: 6px 0 0;
  color: #878a90;
  font-size: 12px;
  line-height: 1.45;
}

.harness-detail-readiness li em {
  grid-column: 2;
  color: #999ca2;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-detail-readiness li.is-current em {
  color: var(--hd-orange);
}

.harness-detail-performance > header button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: #5b5e64;
  cursor: pointer;
}

.harness-detail-performance__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.harness-detail-performance__grid article {
  min-width: 0;
  min-height: 108px;
  display: grid;
  align-content: center;
  gap: 8px;
  padding: 17px 18px;
  border-right: 1px solid #e7e9ec;
  border-radius: 0;
  box-shadow: none;
}

.harness-detail-performance__grid article:last-child {
  border-right: 0;
}

.harness-detail-performance__grid span {
  color: #85888e;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-performance__grid strong {
  color: #2b2d31;
  font-size: 20px;
  font-weight: 700;
}

.harness-detail-performance__grid small {
  color: #979aa0;
  font-size: 12px;
}

.harness-detail-performance__grid article > div {
  height: 5px;
  overflow: hidden;
  border-radius: 0;
  background: #e5e7ea;
}

.harness-detail-performance__grid article > div i {
  height: 100%;
  display: block;
  border-radius: 0;
  background: var(--hd-blue);
}

.harness-detail-performance__grid article:nth-child(2) > div i {
  background: var(--hd-green);
}

.harness-detail-recommendation {
  padding: 18px;
}

.harness-detail-recommendation > header {
  min-height: auto;
  justify-content: flex-start;
  padding: 0 0 15px;
  border-bottom: 0;
  box-shadow: none;
}

.harness-detail-recommendation > header > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-detail-recommendation > strong {
  display: block;
  margin-top: 17px;
  color: #3e6b35;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.harness-detail-recommendation ul {
  display: grid;
  gap: 8px;
  margin: 15px 0 0;
  padding-inline-start: 18px;
  color: #74777d;
  font-size: 12px;
  line-height: 1.45;
}

.harness-detail-recommendation > button {
  width: 100%;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  border: 0;
  background: var(--hd-orange);
  color: #fff;
  cursor: pointer;
}

.harness-detail-meta > header {
  min-height: 66px;
}

.harness-detail-meta dl {
  margin: 0;
  padding: 8px 18px;
}

.harness-detail-meta dl div {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  box-shadow: inset 0 -1px 0 #eceef0;
}

.harness-detail-meta dl div:last-child {
  box-shadow: none;
}

.harness-detail-meta dt,
.harness-detail-meta dd {
  margin: 0;
  font-size: 12px;
}

.harness-detail-meta dt {
  color: #888b91;
}

.harness-detail-meta dd {
  color: #44474d;
  font-weight: 700;
  text-align: right;
}

.harness-current-main,
.harness-current-side {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 18px;
}

.harness-current-version__badge {
  min-width: 54px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border-radius: 4px;
  background: #fff0e9;
  color: #d34d25 !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px !important;
  letter-spacing: 0 !important;
}

.harness-current-version__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 156px;
  gap: 18px;
  padding: 20px;
}

.harness-current-version__change {
  min-width: 0;
  padding: 17px 18px;
  border: 1px solid #e4e6e9;
  border-radius: 5px;
  background: #fafafa;
}

.harness-current-version__change > span {
  color: #85888e;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-version__change h3 {
  margin: 9px 0 0;
  color: #2d2f34;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
}

.harness-current-version__change p {
  margin: 10px 0 0;
  color: #7b7e84;
  font-size: 12px;
  line-height: 1.55;
}

.harness-current-version__change p strong {
  color: #41444a;
}

.harness-current-version__change p em {
  color: var(--hd-green);
  font-style: normal;
  font-weight: 700;
}

.harness-current-version__score {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 6px;
  padding: 16px;
  border: 1px solid #e4e6e9;
  border-radius: 5px;
  background: #fff;
  text-align: center;
}

.harness-current-version__score > span {
  color: #85888e;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-version__score > strong {
  color: #27292e;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.05em;
}

.harness-current-version__score > strong small {
  margin-left: 2px;
  color: #8a8d93;
  font-size: 12px;
  letter-spacing: 0;
}

.harness-current-version__score > em,
.harness-current-latest__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 23px;
  padding: 0 8px;
  border-radius: 999px;
  background: #edf0fb;
  color: var(--hd-blue);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-current-version__score > em.is-ready,
.harness-current-latest__status.is-ready {
  background: #eaf3e6;
  color: var(--hd-green);
}

.harness-current-version__score > em.is-review,
.harness-current-latest__status.is-review {
  background: #fff2df;
  color: #b96e00;
}

.harness-current-version__facts {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin: 0;
  border-top: 1px solid #e7e9ec;
}

.harness-current-version__facts > div {
  min-width: 0;
  min-height: 64px;
  display: grid;
  align-content: center;
  gap: 6px;
  padding: 12px 14px;
  border-right: 1px solid #e7e9ec;
}

.harness-current-version__facts > div:last-child {
  border-right: 0;
}

.harness-current-version__facts dt,
.harness-current-version__facts dd {
  margin: 0;
}

.harness-current-version__facts dt {
  color: #8b8e94;
  font-size: 12px;
}

.harness-current-version__facts dd {
  overflow: hidden;
  color: #41444a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-version__rule-fact dd {
  overflow: visible;
}

.harness-current-version__rule-fact button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2f6339;
  cursor: pointer;
}

.harness-current-version__rule-fact button i {
  font-size: 12px;
  transition: transform 150ms ease;
}

.harness-current-version__rule-fact button:hover i:not(.is-expanded) {
  transform: translateX(3px);
}

.harness-current-version__rule-fact button i.is-expanded {
  transform: rotate(180deg);
}

.harness-current-rules {
  scroll-margin-top: 150px;
}

.harness-current-rules > ol {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
}

.harness-current-rules > ol li {
  min-height: 52px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  padding: 13px 18px;
  border-bottom: 1px solid #eceef0;
}

.harness-current-rules > ol li:last-child {
  border-bottom: 0;
}

.harness-current-rules > ol li > span {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #edf4e9;
  color: #3f713b;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-rules > ol p {
  margin: 4px 0 0;
  color: #46494f;
  font-size: 12px;
  line-height: 1.55;
}

.harness-current-rules__empty {
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  padding: 22px;
  color: #85898f;
  text-align: left;
}

.harness-current-rules__empty > i {
  font-size: 24px;
}

.harness-current-rules__empty strong {
  display: block;
  color: #55595f;
  font-size: 12px;
}

.harness-current-rules__empty p {
  margin: 5px 0 0;
  font-size: 12px;
}

.harness-current-binding-filter {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 12px 18px;
  border-bottom: 1px solid #e7e9ec;
  background: #fafafa;
}

.harness-current-binding-filter button {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #dfe1e5;
  background: #fff;
  color: #696c72;
  cursor: pointer;
}

.harness-current-binding-filter button:hover {
  border-color: #b8bbc1;
  color: #33353a;
}

.harness-current-binding-filter button.is-active {
  border-color: #2f3135;
  background: #2f3135;
  color: #fff;
}

.harness-current-binding-filter button i {
  font-size: 12px;
}

.harness-current-binding-filter button em {
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef0f2;
  color: #74777d;
  font-style: normal;
}

.harness-current-binding-filter button.is-active em {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.harness-current-binding-list {
  min-width: 0;
}

.harness-current-binding-list__head,
.harness-current-binding-list article {
  min-width: 0;
  display: grid;
  grid-template-columns: 118px minmax(0, 1fr) 74px 86px 92px;
  align-items: center;
  gap: 14px;
  padding-inline: 18px;
}

.harness-current-binding-list__head {
  min-height: 36px;
  border-bottom: 1px solid #e7e9ec;
  background: #f7f8f9;
  color: #91949a;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-binding-list article {
  min-height: 66px;
  border-bottom: 1px solid #e7e9ec;
  background: #fff;
}

.harness-current-binding-list article:last-child {
  border-bottom: 0;
}

.harness-current-binding-list article.is-empty {
  background: #fafafa;
}

.harness-current-binding-list__type {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;
}

.harness-current-binding-list__type i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 4px;
  background: #f0f1f2;
  color: #666a71;
  font-size: 12px;
}

.harness-current-binding-list__type i.fa-database {
  color: var(--hd-blue);
}

.harness-current-binding-list__type i.fa-file-lines {
  color: var(--hd-orange);
}

.harness-current-binding-list__type i.fa-diagram-project {
  color: var(--hd-green);
}

.harness-current-binding-list__type span {
  color: #55585e;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-binding-list__subject {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.harness-current-binding-list__subject strong,
.harness-current-binding-list__subject small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-binding-list__subject strong {
  color: #303237;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-binding-list__subject small {
  color: #999ca2;
  font-size: 12px;
}

.harness-current-binding-list article.is-empty .harness-current-binding-list__subject small {
  overflow: visible;
  line-height: 1.45;
  text-overflow: clip;
  white-space: normal;
}

.harness-current-binding-list__version {
  color: #4d5056;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-binding-list__status {
  min-height: 23px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: start;
  padding: 0 8px;
  border-radius: 999px;
  background: #eaf3e6;
  color: var(--hd-green);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.harness-current-binding-list article.is-empty .harness-current-binding-list__status {
  background: #eef0f2;
  color: #7d8086;
}

.harness-current-binding-list__readonly {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid #dce4dc;
  border-radius: 4px;
  background: #f5f8f4;
  color: #718075;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.harness-current-binding-list article > button {
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #dfe1e5;
  background: #fff;
  color: #62656b;
  cursor: pointer;
}

.harness-current-binding-list article > button:hover {
  border-color: #b8bbc1;
  color: var(--hd-orange);
}

.harness-current-resource-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  padding: 18px;
}

.harness-current-resource-grid.is-single {
  grid-template-columns: minmax(0, 1fr);
}

.harness-current-resource {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e1e3e6;
  border-radius: 6px;
  background: #fff;
}

.harness-current-resource > header {
  min-width: 0;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  padding: 15px;
  border-bottom: 1px solid #e7e9ec;
  background: #fafafa;
}

.harness-current-resource > header > i {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  background: #edf0fb;
  color: var(--hd-blue);
  font-size: 13px;
}

.harness-current-resource--survey > header > i {
  background: #fff0e9;
  color: var(--hd-orange);
}

.harness-current-resource > header > div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.harness-current-resource > header span {
  color: #85888e;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-resource > header strong {
  overflow: hidden;
  color: #303237;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-resource > header em {
  min-height: 23px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: #eaf3e6;
  color: var(--hd-green);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.harness-current-resource dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.harness-current-resource dl > div {
  min-width: 0;
  display: grid;
  gap: 5px;
  padding: 14px 15px;
  border-right: 1px solid #e7e9ec;
}

.harness-current-resource dl > div:last-child {
  border-right: 0;
}

.harness-current-resource dt,
.harness-current-resource dd {
  margin: 0;
}

.harness-current-resource dt {
  color: #979aa0;
  font-size: 12px;
}

.harness-current-resource dd {
  overflow: hidden;
  color: #45484e;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-resource > button {
  width: calc(100% - 30px);
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 0 15px 15px;
  border: 1px solid #dfe1e5;
  background: #fff;
  color: #5e6167;
  cursor: pointer;
}

.harness-current-resource > button:hover {
  border-color: #b8bbc1;
  color: var(--hd-orange);
}

.harness-current-projects {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 15px;
  padding: 0 18px 18px;
}

.harness-current-binding-filter + .harness-current-projects {
  padding-top: 18px;
}

.harness-current-projects__label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px;
  border: 1px solid #e1e3e6;
  border-radius: 5px;
  background: #fafafa;
}

.harness-current-projects__label > i {
  color: var(--hd-green);
  font-size: 13px;
}

.harness-current-projects__label > div {
  display: grid;
  gap: 4px;
}

.harness-current-projects__label span {
  color: #43464c;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-projects__label small {
  color: #999ca2;
  font-size: 12px;
  line-height: 1.4;
}

.harness-current-project-list {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.harness-current-project-list > button {
  min-width: 0;
  min-height: 48px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 12px;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid #e1e3e6;
  background: #fff;
  color: #4b4e54;
  cursor: pointer;
  text-align: left;
}

.harness-current-project-list > button:hover {
  border-color: #b8bbc1;
  background: #fafafa;
}

.harness-current-project-list > button.is-empty {
  background: #fafafa;
}

.harness-current-project-list > button > span {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.harness-current-project-list strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-project-list small {
  color: #9a9da3;
  font-size: 12px;
}

.harness-current-project-list em {
  color: var(--hd-green);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.harness-current-project-list i {
  color: #a3a6ac;
  font-size: 12px;
}

.harness-current-latest__status {
  flex: 0 0 auto;
  letter-spacing: 0 !important;
}

.harness-current-latest__body {
  padding: 18px;
}

.harness-current-latest__run {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e7e9ec;
}

.harness-current-latest__run span {
  color: #45484e;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-latest__run small {
  color: #989ba1;
  font-size: 12px;
}

.harness-current-latest__metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #e4e6e9;
  border-radius: 5px;
}

.harness-current-latest__metrics article {
  min-width: 0;
  display: grid;
  gap: 6px;
  padding: 13px 10px;
  border-right: 1px solid #e4e6e9;
}

.harness-current-latest__metrics article:last-child {
  border-right: 0;
}

.harness-current-latest__metrics span {
  color: #909399;
  font-size: 12px;
}

.harness-current-latest__metrics strong {
  color: #323439;
  font-size: 12px;
  font-weight: 700;
}

.harness-current-latest__context {
  display: grid;
  gap: 0;
  margin: 14px 0 0;
}

.harness-current-latest__context div {
  min-width: 0;
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid #eceef0;
}

.harness-current-latest__context div:last-child {
  border-bottom: 0;
}

.harness-current-latest__context dt,
.harness-current-latest__context dd {
  min-width: 0;
  margin: 0;
  font-size: 12px;
}

.harness-current-latest__context dt {
  color: #94979d;
}

.harness-current-latest__context dd {
  overflow: hidden;
  color: #4a4d53;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-current-next {
  padding: 18px;
}

.harness-current-next > header {
  min-height: auto;
  justify-content: flex-start;
  padding: 0;
  border-bottom: 0;
}

.harness-current-next > header > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-current-next > strong {
  display: block;
  margin-top: 17px;
  color: #3e6b35;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.harness-current-next > p {
  margin: 9px 0 0;
  color: #7b7e84;
  font-size: 12px;
  line-height: 1.55;
}

.harness-detail-tests,
.harness-detail-versions {
  min-height: 480px;
}

.harness-detail-tests > header,
.harness-detail-versions > header {
  min-height: 88px;
  padding: 16px 20px;
}

.harness-detail-tests > header p,
.harness-detail-versions > header p {
  margin: 5px 0 0;
  color: #8b8e94;
  font-size: 12px;
}

.harness-detail-test-table {
  overflow-x: auto;
}

.harness-detail-test-table table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 0;
}

.harness-detail-test-table th {
  height: 44px;
  padding: 0 16px;
  background: #f7f7f7;
  color: #65686e;
  border-bottom: 1px solid #e1e3e6;
  border-radius: 0;
  box-shadow: none;
  font-size: 12px;
  text-align: left;
}

.harness-detail-test-table td {
  height: 66px;
  padding: 0 16px;
  color: #686b71;
  border-bottom: 1px solid #e7e9ec;
  border-radius: 0;
  box-shadow: none;
  font-size: 12px;
}

.harness-detail-test-table td strong {
  color: #2f3135;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.harness-detail-test-table td span {
  display: inline-flex;
  padding: 5px 7px;
  border-radius: 4px;
  background: #f0f1f2;
  color: #666970;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-test-table td span.is-pass {
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-detail-test-table td span.is-review {
  background: #fff2df;
  color: #b96e00;
}

.harness-history-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-bottom: 1px solid #e1e3e6;
}

.harness-history-summary article {
  min-width: 0;
  min-height: 82px;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 14px 18px;
  border-right: 1px solid #e7e9ec;
}

.harness-history-summary article:last-child {
  border-right: 0;
}

.harness-history-summary article > i {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 5px;
  background: #f0f1f2;
  color: var(--hd-blue);
  font-size: 12px;
}

.harness-history-summary article:nth-child(2) > i {
  color: var(--hd-green);
}

.harness-history-summary article:nth-child(3) > i {
  color: #68499a;
}

.harness-history-summary article:nth-child(4) > i {
  color: var(--hd-orange);
}

.harness-history-summary article > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.harness-history-summary span {
  color: #898c92;
  font-size: 12px;
  font-weight: 700;
}

.harness-history-summary strong {
  overflow: hidden;
  color: #2f3135;
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-summary small {
  overflow: hidden;
  color: #a0a3a9;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-list {
  min-width: 0;
  overflow-x: auto;
}

.harness-history-list__head,
.harness-history-row {
  width: 100%;
  min-width: 1080px;
  display: grid;
  grid-template-columns: 170px 74px minmax(145px, 1fr) minmax(145px, 1fr) 125px 58px 82px 14px;
  align-items: center;
  gap: 12px;
  padding-inline: 18px;
}

.harness-history-list__head {
  min-height: 40px;
  border-bottom: 1px solid #e1e3e6;
  background: #f7f8f9;
  color: #8d9096;
  font-size: 12px;
  font-weight: 700;
}

.harness-history-row {
  min-height: 76px;
  border: 0;
  border-bottom: 1px solid #e7e9ec;
  background: #fff;
  color: #55585e;
  cursor: pointer;
  text-align: left;
}

.harness-history-row:hover,
.harness-history-row.is-open {
  background: #fafafa;
}

.harness-history-row__run,
.harness-history-row__resource {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.harness-history-row__run > em {
  justify-self: start;
  padding: 4px 6px;
  background: #edf0fb;
  color: var(--hd-blue);
  font-style: normal;
}

.harness-history-row__run > em.is-application {
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-history-row__run strong {
  overflow: hidden;
  color: #34363b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-row__run small,
.harness-history-row__resource small {
  overflow: hidden;
  color: #999ca2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-row__version {
  color: #d34d25;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.harness-history-row__resource strong,
.harness-history-row__project {
  overflow: hidden;
  color: #4b4e54;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-row__score {
  color: #292b30;
}

.harness-history-row__status {
  justify-self: start;
  padding: 5px 7px;
  background: #eef0f2;
  color: #777a80;
  font-style: normal;
  white-space: nowrap;
}

.harness-history-row__status.is-pass {
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-history-row__status.is-review {
  background: #fff2df;
  color: #b96e00;
}

.harness-history-row > i {
  color: #a0a3a9;
  font-size: 12px;
}

.harness-history-detail {
  min-width: 1080px;
  padding: 18px;
  border-bottom: 1px solid #dfe1e5;
  background: #f8f9fa;
}

.harness-history-detail__metrics {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #e1e3e6;
  border-radius: 5px;
  background: #fff;
}

.harness-history-detail__metrics article {
  min-width: 0;
  display: grid;
  gap: 6px;
  padding: 12px 14px;
  border-right: 1px solid #e7e9ec;
}

.harness-history-detail__metrics article:last-child {
  border-right: 0;
}

.harness-history-detail__metrics span,
.harness-history-detail__snapshot span {
  color: #93969c;
  font-size: 12px;
}

.harness-history-detail__metrics strong,
.harness-history-detail__snapshot strong {
  overflow: hidden;
  color: #3d4046;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-history-detail__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 14px;
  margin-top: 14px;
}

.harness-history-detail__body > section,
.harness-history-detail__body > aside,
.harness-history-application {
  padding: 15px;
  border: 1px solid #e1e3e6;
  border-radius: 5px;
  background: #fff;
}

.harness-history-detail__body header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.harness-history-detail__body header span {
  color: #42454b;
  font-size: 12px;
  font-weight: 700;
}

.harness-history-detail__body header small {
  color: #a0a3a9;
  font-size: 12px;
}

.harness-history-score-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  margin-top: 14px;
}

.harness-history-score-list article > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #6e7177;
  font-size: 12px;
}

.harness-history-score-list article > div:last-child {
  height: 5px;
  margin-top: 6px;
  overflow: hidden;
  background: #e5e7ea;
}

.harness-history-score-list article > div:last-child i {
  height: 100%;
  display: block;
  background: var(--hd-green);
}

.harness-history-detail__body ul {
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding-left: 16px;
  color: #75787e;
  font-size: 12px;
  line-height: 1.45;
}

.harness-history-application {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}

.harness-history-application > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-history-application strong {
  color: #3d4046;
  font-size: 12px;
}

.harness-history-application p {
  margin: 5px 0 0;
  color: #85888e;
  font-size: 12px;
}

.harness-history-detail__snapshot {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid #e1e3e6;
  border-radius: 5px;
  background: #fff;
}

.harness-history-detail__snapshot > div:not(.harness-history-detail__actions) {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.harness-history-detail__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.harness-history-detail__actions button {
  height: 30px;
  padding: 0 9px;
  border: 1px solid #dfe1e5;
  background: #fff;
  color: #5c5f65;
  cursor: pointer;
}

.harness-history-detail__actions button:last-child {
  border-color: #2f3135;
  background: #2f3135;
  color: #fff;
}

.harness-history-empty {
  min-height: 180px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: #96999f;
}

.harness-history-empty strong {
  color: #55585e;
  font-size: 12px;
}

.harness-history-empty p {
  margin: 0;
  font-size: 12px;
}

.harness-history-footer {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid #e1e3e6;
  color: #74777d;
  font-size: 12px;
}

.harness-history-footer small {
  color: #9a9da3;
  font-size: 12px;
}

.harness-detail-versions > header > span {
  color: #777a80;
  font-size: 12px;
  letter-spacing: 0;
}

.harness-version-controls {
  display: grid;
  grid-template-columns: minmax(170px, 0.45fr) minmax(420px, 1.5fr) minmax(280px, 0.8fr);
  align-items: center;
  gap: 18px;
  padding: 20px;
  border-bottom: 1px solid #e1e3e6;
  background: #f8f9f8;
}

.harness-version-controls__heading {
  display: grid;
  gap: 5px;
}

.harness-version-controls__heading span {
  color: var(--hd-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.harness-version-controls__heading strong {
  color: #4b4e54;
  font-size: 12px;
  line-height: 1.45;
}

.harness-version-controls__selectors {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px minmax(0, 1fr);
  align-items: end;
  gap: 10px;
}

.harness-version-controls__selectors label {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.harness-version-controls__selectors label > span {
  color: #6f7379;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-controls__selectors select {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #cfd3d8;
  border-radius: 8px;
  background: #fff;
  color: #2f3237;
  font-size: 13px;
  font-weight: 700;
}

.harness-version-controls__selectors select:focus {
  outline: 0;
  border-color: #6f756e;
  box-shadow: 0 0 0 3px rgba(63, 125, 58, 0.1);
}

.harness-detail-versions .harness-version-controls {
  position: relative;
  z-index: 20;
  overflow: visible;
}

.harness-version-selector {
  position: relative;
  min-width: 0;
  display: grid;
  gap: 7px;
}

.harness-version-selector__label {
  color: #6f7379;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-selector__trigger {
  width: 100%;
  height: 44px;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 13px;
  border: 1px solid #cfd3d8 !important;
  outline: 0;
  color: #2f3237;
  background: #fff !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.harness-version-selector__trigger > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-version-selector__trigger > i {
  flex: 0 0 auto;
  color: #858a90;
  font-size: 12px;
  transition: transform 150ms ease;
}

.harness-version-selector.is-open .harness-version-selector__trigger {
  border-color: #6f756e !important;
  box-shadow: 0 0 0 3px rgba(63, 125, 58, 0.1) !important;
}

.harness-version-selector.is-open .harness-version-selector__trigger > i {
  color: #4f6e59;
  transform: rotate(180deg);
}

.harness-version-selector__menu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  left: 0;
  z-index: 100;
  max-height: 300px;
  display: grid;
  gap: 2px;
  padding: 6px;
  overflow-y: auto;
  overscroll-behavior: contain;
  border: 1px solid #d5d9d5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(35, 43, 37, 0.18);
  scrollbar-width: thin;
}

.harness-version-selector__menu button {
  width: 100%;
  min-height: 35px;
  display: grid;
  grid-template-columns: 17px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  border: 0 !important;
  outline: 0;
  color: #4c514e;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.harness-version-selector__menu button > i {
  color: transparent;
  font-size: 12px;
}

.harness-version-selector__menu button:hover,
.harness-version-selector__menu button:focus-visible {
  color: #315846;
  background: #eef4f0 !important;
}

.harness-version-selector__menu button.is-selected {
  color: #244d3a;
  background: #e7f0ea !important;
}

.harness-version-selector__menu button.is-selected > i {
  color: #32654d;
}

.harness-version-swap {
  width: 42px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 1px solid #d6d9dd;
  background: #fff;
  color: #60646a;
  cursor: pointer;
}

.harness-version-swap:hover:not(:disabled) {
  border-color: #8c918b;
  color: var(--hd-green);
}

.harness-version-swap:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.harness-version-same-condition {
  height: 44px;
  min-height: 44px;
  display: flex;
  align-self: end;
  align-items: center;
  gap: 9px;
  padding: 5px 12px;
  border: 1px solid #d6d9dd;
  background: #fff;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  appearance: none;
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.harness-version-same-condition:hover {
  border-color: #b9bdc5;
  background: #fcfcfc;
}

.harness-version-same-condition:focus-visible {
  outline: 0;
  border-color: #565960;
  box-shadow: 0 0 0 3px rgba(47, 49, 53, 0.14);
}

.harness-version-same-condition.is-checked {
  border-color: #7b7f87;
  background: #f6f7f7;
}

.harness-version-same-condition__box {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #b9bdc4;
  background: #fff;
  color: #fff;
}

.harness-version-same-condition.is-checked .harness-version-same-condition__box {
  border-color: #2f3135;
  background: #2f3135;
}

.harness-version-same-condition__copy {
  display: grid;
  gap: 2px;
}

.harness-version-same-condition strong {
  color: #4b4e54;
}

.harness-version-same-condition small {
  color: #9a9da3;
}

.harness-version-condition-notice {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 18px 20px 0;
  padding: 14px 16px;
  border: 1px solid #dbe8d6;
  border-radius: 8px;
  background: #f2f7ef;
  color: var(--hd-green);
}

.harness-version-condition-notice.is-warning {
  border-color: #f1d7ad;
  background: #fff8eb;
  color: #b96e00;
}

.harness-version-condition-notice.is-strict {
  border-color: #efc5b8;
  background: #fff3ee;
  color: #c84d28;
}

.harness-version-condition-notice > i {
  font-size: 13px;
}

.harness-version-condition-notice > div {
  display: grid;
  gap: 3px;
}

.harness-version-condition-notice strong {
  font-size: 12px;
}

.harness-version-condition-notice p {
  margin: 0;
  color: #85888e;
  font-size: 12px;
  line-height: 1.45;
}

.harness-version-pair {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px minmax(0, 1fr);
  align-items: stretch;
  gap: 18px;
  padding: 20px;
}

.harness-version-pair > article {
  min-width: 0;
  padding: 20px;
  border: 1px solid #e1e3e6;
  border-radius: 10px;
  background: #fff;
}

.harness-version-pair > article.is-current {
  border-color: #efcbbb;
  background: #fffaf7;
}

.harness-version-pair > article > span {
  color: #8c8f95;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-pair > article > strong {
  display: inline-block;
  margin: 0 0 0 9px;
  color: #2d2f34;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 20px;
  font-weight: 700;
}

.harness-version-pair > article > em {
  display: inline-flex;
  margin-left: 7px;
  padding: 5px 7px;
  border-radius: 5px;
  background: #fff0e9;
  color: #d34d25;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-version-pair h3 {
  margin: 14px 0 0;
  color: #45484e;
  font-size: 13px;
  line-height: 1.55;
}

.harness-version-pair p {
  margin: 7px 0 0;
  color: #92959b;
  font-size: 12px;
}

.harness-version-pair > div {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: var(--hd-orange);
}

.harness-version-pair > div i {
  font-size: 16px;
}

.harness-version-pair > div span {
  font-size: 12px;
  font-weight: 700;
}

.harness-version-metric-table,
.harness-version-change-card,
.harness-version-condition-card,
.harness-version-score-card,
.harness-version-failure-card {
  margin-inline: 20px;
  overflow: hidden;
  border: 1px solid #e1e3e6;
  border-radius: 10px;
  background: #fff;
}

.harness-version-metric-table > header,
.harness-version-change-card > header,
.harness-version-condition-card > header,
.harness-version-score-card > header,
.harness-version-failure-card > header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 15px 18px;
  border-bottom: 1px solid #e7e9ec;
}

.harness-version-metric-table > header span,
.harness-version-change-card > header span,
.harness-version-condition-card > header span,
.harness-version-score-card > header span,
.harness-version-failure-card > header span {
  color: var(--hd-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.harness-version-metric-table > header h3,
.harness-version-change-card > header h3,
.harness-version-condition-card > header h3,
.harness-version-score-card > header h3,
.harness-version-failure-card > header h3 {
  margin: 4px 0 0;
  color: #303237;
  font-size: 15px;
}

.harness-version-metric-table > header small,
.harness-version-change-card > header small,
.harness-version-condition-card > header small,
.harness-version-score-card > header small,
.harness-version-failure-card > header small {
  color: #999ca2;
  font-size: 12px;
}

.harness-version-metric-table__head,
.harness-version-metric-table > article {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) repeat(3, minmax(90px, 0.55fr));
  align-items: center;
  gap: 12px;
  padding-inline: 15px;
}

.harness-version-metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 18px 18px;
  background: #fafbfa;
}

.harness-version-metric-grid > article {
  min-width: 0;
  display: grid;
  gap: 12px;
  padding: 15px;
  border: 1px solid #e0e3e5;
  border-radius: 9px;
  background: #fff;
}

.harness-version-metric-grid > article > span {
  color: #74787e;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-metric-grid > article > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 7px;
}

.harness-version-metric-grid > article > div strong {
  overflow: hidden;
  color: #303338;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-version-metric-grid > article > div strong:last-child {
  text-align: right;
}

.harness-version-metric-grid > article > div i {
  color: #b0b4b9;
  font-size: 12px;
}

.harness-version-metric-grid > article > em {
  justify-self: start;
  padding: 5px 7px;
  border-radius: 5px;
  background: #fff1df;
  color: #aa6500;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-version-metric-grid > article > em.is-improved {
  background: #edf5e9;
  color: var(--hd-green);
}

.harness-version-metric-table__head {
  min-height: 34px;
  background: #f7f8f9;
  color: #92959b;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-metric-table > article {
  min-height: 48px;
  border-top: 1px solid #e7e9ec;
  color: #55585e;
  font-size: 12px;
}

.harness-version-metric-table > article strong {
  color: #3e4147;
}

.harness-version-metric-table > article em {
  justify-self: start;
  padding: 4px 6px;
  border-radius: 3px;
  background: #fff2df;
  color: #b96e00;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-version-metric-table > article em.is-improved {
  background: #edf4e9;
  color: var(--hd-green);
}

.harness-version-comparison-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(360px, 0.85fr);
  align-items: start;
  gap: 16px;
  margin: 16px 20px 0;
}

.harness-version-comparison-grid > section {
  margin: 0;
}

.harness-version-rule-groups,
.harness-version-failure-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
  padding: 16px;
  background: #fafbfa;
}

.harness-version-rule-groups > article,
.harness-version-failure-groups > article {
  min-width: 0;
  align-self: start;
  padding: 15px;
  border: 1px solid #e1e4e6;
  border-radius: 9px;
  background: #fff;
}

.harness-version-rule-groups > article:last-child,
.harness-version-failure-groups > article:last-child {
  border-right: 1px solid #e1e4e6;
}

.harness-version-rule-groups > article.is-added {
  border-top: 3px solid #67935e;
}

.harness-version-rule-groups > article.is-modified {
  border-top: 3px solid #d39a3e;
}

.harness-version-rule-groups > article.is-removed {
  border-top: 3px solid #cf775d;
}

.harness-version-rule-groups article > header,
.harness-version-failure-groups article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.harness-version-rule-groups header span,
.harness-version-failure-groups header span {
  color: #55585e;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-rule-groups header em,
.harness-version-failure-groups header em {
  min-width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eef0f2;
  color: #777a80;
  font-size: 12px;
  font-style: normal;
}

.harness-version-rule-groups ul,
.harness-version-failure-groups ul {
  display: grid;
  gap: 9px;
  margin: 13px 0 0;
  padding: 0;
  color: #73767c;
  font-size: 12px;
  line-height: 1.6;
  list-style: none;
}

.harness-version-rule-groups > article > p,
.harness-version-failure-groups > article > p {
  margin: 11px 0 0;
  color: #a0a3a9;
  font-size: 12px;
}

.harness-version-rule-groups li {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 9px;
  align-items: start;
  padding: 10px;
  border-radius: 7px;
  background: #f6f7f6;
}

.harness-version-rule-groups li > span {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  background: #fff;
  color: #74787e;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-rule-groups li > p {
  margin: 1px 0 0;
  color: #4f5358;
  font-size: 12px;
  line-height: 1.6;
  word-break: keep-all;
}

.harness-version-rule-more {
  width: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 11px;
  border: 1px solid #dce0e2;
  background: #fff;
  color: #5d6267;
  cursor: pointer;
}

.harness-version-rule-more:hover {
  background: #f5f6f5;
}

.harness-version-failure-groups li {
  position: relative;
  padding-left: 14px;
}

.harness-version-failure-groups li::before {
  position: absolute;
  top: 0.7em;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: #aeb2b6;
  content: "";
}

.harness-version-condition-table > header,
.harness-version-condition-table > article {
  display: grid;
  grid-template-columns: 94px minmax(0, 1fr) minmax(0, 1fr) 50px;
  align-items: center;
  gap: 10px;
  padding: 0 15px;
}

.harness-version-condition-table > header {
  min-height: 38px;
  background: #f7f8f9;
  color: #91949a;
  font-size: 12px;
  font-weight: 700;
}

.harness-version-condition-table > article {
  min-height: 52px;
  border-top: 1px solid #e7e9ec;
  color: #5d6066;
  font-size: 12px;
  line-height: 1.45;
}

.harness-version-condition-table > article.is-different {
  background: #fffaf3;
}

.harness-version-condition-table strong {
  color: #3f4248;
}

.harness-version-condition-table em {
  justify-self: start;
  padding: 4px 6px;
  border-radius: 5px;
  background: #fff0dc;
  color: #a86400;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-version-condition-table em.is-same {
  background: #edf5e9;
  color: var(--hd-green);
}

.harness-version-score-card,
.harness-version-failure-card {
  margin-top: 14px;
}

.harness-version-score-comparison {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
  padding: 20px;
}

.harness-version-score-comparison article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.harness-version-score-comparison article > header strong {
  color: #45484e;
  font-size: 12px;
}

.harness-version-score-comparison article > header em {
  color: var(--hd-green);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.harness-version-score-comparison article > div {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 38px;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #85888e;
  font-size: 12px;
}

.harness-version-score-comparison article > div > div {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #e5e7ea;
}

.harness-version-score-comparison article > div i {
  height: 100%;
  display: block;
  background: #9da2ad;
}

.harness-version-score-comparison article > div i.is-compare {
  background: var(--hd-green);
}

.harness-version-score-comparison article > div strong {
  color: #4b4e54;
  font-size: 12px;
  text-align: right;
}

.harness-version-section-empty {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  color: #8a8e94;
}

.harness-version-section-empty > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: #f1f3f2;
  color: #777c79;
  font-size: 16px;
}

.harness-version-section-empty > div {
  display: grid;
  gap: 4px;
}

.harness-version-section-empty strong {
  color: #4f5358;
  font-size: 12px;
}

.harness-version-section-empty p {
  margin: 0;
  font-size: 12px;
}

.harness-version-failure-card {
  margin-bottom: 14px;
}

.harness-version-failure-groups > article.is-resolved header span {
  color: var(--hd-green);
}

.harness-version-failure-groups > article.is-remaining header span {
  color: #b96e00;
}

.harness-version-failure-groups > article.is-new header span {
  color: #c84d28;
}

.harness-version-actions {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
  border-top: 1px solid #e1e3e6;
  background: #fafafa;
}

.harness-version-actions > div:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #85888e;
  font-size: 12px;
}

.harness-version-actions > div:first-child i {
  color: var(--hd-green);
}

.harness-version-actions > div:last-child {
  display: flex;
  align-items: center;
  gap: 7px;
}

.harness-version-actions button {
  height: 38px;
  padding: 0 13px;
  border: 1px solid #dfe1e5;
  background: #fff;
  color: #55585e;
  cursor: pointer;
}

.harness-version-actions button:last-child {
  border-color: #2f3135;
  background: #2f3135;
  color: #fff;
}

.harness-version-empty {
  min-height: 300px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 9px;
  color: #a0a3a9;
  text-align: center;
}

.harness-version-empty > i {
  font-size: 28px;
}

.harness-version-empty strong {
  color: #4b4e54;
  font-size: 12px;
}

.harness-version-empty p {
  margin: 0;
  font-size: 12px;
}

.harness-detail-version-list {
  padding: 8px 20px 24px;
}

.harness-detail-version-list article {
  min-height: 96px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 210px;
  gap: 14px;
  align-items: center;
  padding: 15px 4px;
  box-shadow: inset 0 -1px 0 #e7e9ec;
}

.harness-detail-version-list article:last-child {
  box-shadow: none;
}

.harness-detail-version-marker {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #f0f1f2;
  color: #686b71;
}

.harness-detail-version-copy {
  min-width: 0;
}

.harness-detail-version-copy header {
  display: flex;
  align-items: center;
  gap: 7px;
}

.harness-detail-version-copy header strong {
  color: #2c2f34;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  font-weight: 700;
}

.harness-detail-version-copy header span {
  padding: 4px 6px;
  border-radius: 3px;
  background: #fff0e9;
  color: #d6522b;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-version-copy h3 {
  margin: 7px 0 0;
  color: #4c4f55;
  font-size: 12px;
}

.harness-detail-version-copy p {
  margin: 5px 0 0;
  color: #91949a;
  font-size: 12px;
}

.harness-detail-version-list dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.harness-detail-version-list dl div {
  display: grid;
  gap: 5px;
  padding: 5px 14px;
  box-shadow: inset -1px 0 0 #e6e8eb;
}

.harness-detail-version-list dl div:last-child {
  box-shadow: none;
}

.harness-detail-version-list dt,
.harness-detail-version-list dd {
  margin: 0;
}

.harness-detail-version-list dt {
  color: #92959b;
  font-size: 12px;
}

.harness-detail-version-list dd {
  color: #34363b;
  font-size: 12px;
  font-weight: 700;
}

.harness-detail-empty {
  min-height: 420px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 10px;
  border: 1px solid var(--hd-line);
  border-radius: 6px;
  background: #fff;
  text-align: center;
}

.harness-detail-empty > i {
  color: #b2b5ba;
  font-size: 32px;
}

.harness-detail-empty h2 {
  margin: 0;
  color: #2e3035;
  font-size: 18px;
}

.harness-detail-empty p {
  margin: 0;
  color: #85888e;
  font-size: 12px;
}

.harness-detail-empty button {
  min-height: 38px;
  margin-top: 4px;
  padding: 0 14px;
  border: 0;
  background: #2f3135;
  color: #fff;
}

.harness-edit-backdrop {
  position: fixed;
  inset: 0;
  z-index: 150;
  display: grid;
  place-items: center;
  padding: 28px;
  background: rgba(31, 35, 32, 0.58);
  backdrop-filter: blur(4px);
}

.harness-edit-modal {
  width: min(760px, 100vw - 56px);
  max-height: calc(100vh - 56px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #dce1da;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 30px 88px rgba(29, 34, 28, 0.28);
}

.harness-edit-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 28px 30px 24px;
  border-bottom: 1px solid #e5e8e3;
}

.harness-edit-modal > header span {
  color: #cf542f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.harness-edit-modal > header h2 {
  margin: 8px 0 0;
  color: #292d29;
  font-size: 25px;
  letter-spacing: -0.035em;
}

.harness-edit-modal > header p {
  margin: 8px 0 0;
  color: #777c77;
  font-size: 12px;
}

.harness-edit-modal > header button {
  width: 38px;
  height: 38px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  padding: 0;
  border: 1px solid #daddd9;
  background: #fff;
  color: #626762;
  cursor: pointer;
}

.harness-edit-modal > main {
  display: grid;
  gap: 24px;
  padding: 26px 30px 30px;
  overflow-y: auto;
}

.harness-edit-fields {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(140px, 0.7fr) minmax(150px, 0.7fr);
  gap: 14px;
}

.harness-edit-fields label,
.harness-edit-rules {
  min-width: 0;
  display: grid;
  gap: 9px;
}

.harness-edit-fields label > span,
.harness-edit-rules > span {
  color: #3d423d;
  font-size: 12px;
  font-weight: 700;
}

.harness-edit-fields input,
.harness-edit-fields select,
.harness-edit-rules textarea {
  width: 100%;
  border: 1px solid #cfd4ce;
  border-radius: 7px;
  outline: none;
  background: #fff;
  color: #303530;
  font: inherit;
  font-size: 13px;
}

.harness-edit-fields input,
.harness-edit-fields select {
  height: 46px;
  padding: 0 13px;
}

.harness-edit-fields input:focus,
.harness-edit-fields select:focus,
.harness-edit-rules textarea:focus {
  border-color: #d45d38;
  box-shadow: 0 0 0 3px rgba(212, 93, 56, 0.12);
}

.harness-edit-score-field {
  position: relative;
}

.harness-edit-score-field input {
  padding-right: 38px;
}

.harness-edit-score-field em {
  position: absolute;
  top: 50%;
  right: 13px;
  color: #777c77;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  pointer-events: none;
  transform: translateY(-50%);
}

.harness-edit-rules small {
  color: #858a85;
  font-size: 12px;
  line-height: 1.5;
}

.harness-edit-rules textarea {
  min-height: 180px;
  padding: 14px;
  resize: vertical;
  line-height: 1.6;
}

.harness-edit-modal > footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 30px;
  border-top: 1px solid #e5e8e3;
  background: #fafbf9;
}

.harness-edit-modal > footer button {
  min-width: 92px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  border: 1px solid #cfd4ce;
  background: #fff;
  color: #535853;
  cursor: pointer;
}

.harness-edit-modal > footer .harness-edit-submit {
  border-color: #30352f;
  background: #30352f;
  color: #fff;
}

.harness-edit-modal button:disabled {
  cursor: wait;
  opacity: 0.58;
}

.harness-connection-backdrop {
  position: fixed;
  inset: 0;
  z-index: 160;
  display: grid;
  place-items: center;
  padding: 28px;
  background: rgba(31, 35, 32, 0.58);
  backdrop-filter: blur(4px);
}

.harness-connection-modal {
  width: min(620px, 100vw - 56px);
  max-height: calc(100vh - 56px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #dce1da;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 30px 88px rgba(29, 34, 28, 0.28);
}

.harness-connection-modal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 25px 26px 22px;
  border-bottom: 1px solid #e5e8e3;
}

.harness-connection-modal > header span {
  color: var(--hd-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.harness-connection-modal > header h2 {
  margin: 7px 0 0;
  color: #292d29;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.harness-connection-modal > header p {
  margin: 7px 0 0;
  color: #777c77;
  font-size: 12px;
  line-height: 1.55;
}

.harness-connection-modal > header > button {
  width: 36px;
  height: 36px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid #daddd9;
  background: #fff;
  color: #626762;
  cursor: pointer;
}

.harness-connection-modal > main {
  display: grid;
  align-content: start;
  gap: 9px;
  padding: 18px 20px;
  overflow-y: auto;
  background: #f7f8f6;
}

.harness-connection-option {
  width: 100%;
  min-height: 70px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  padding: 12px 14px;
  border: 1px solid #dfe3dd;
  background: #fff;
  color: #343834;
  cursor: pointer;
  text-align: left;
}

.harness-connection-option:hover:not(:disabled) {
  border-color: #d7613c;
  box-shadow: 0 5px 18px rgba(49, 55, 48, 0.07);
}

.harness-connection-option > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  background: #eef3ec;
  color: var(--hd-green);
  font-size: 13px;
}

.harness-connection-option > span {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.harness-connection-option strong,
.harness-connection-option small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.harness-connection-option small {
  color: #858a85;
}

.harness-connection-option em {
  min-width: 64px;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 9px;
  background: #2f3430;
  color: #fff;
  font-style: normal;
}

.harness-connection-option.is-connected {
  border-color: #d9e4d6;
  background: #fbfdfb;
}

.harness-connection-option.is-connected em {
  background: #e9f2e6;
  color: var(--hd-green);
}

.harness-connection-option:disabled {
  cursor: default;
  opacity: 0.78;
}

.harness-connection-empty {
  min-height: 140px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 10px;
  color: #8a8f89;
}

.harness-connection-empty i {
  font-size: 25px;
}

.harness-connection-empty strong {
  font-size: 12px;
}

.harness-connection-modal > footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-top: 1px solid #e5e8e3;
  background: #fff;
}

.harness-connection-modal > footer button {
  min-width: 76px;
  height: 38px;
  border: 1px solid #cfd4ce;
  background: #fff;
  color: #535853;
  cursor: pointer;
}

.harness-connection-modal button:disabled {
  cursor: wait;
}

@media (max-width: 1100px) {
  .harness-detail-header__actions .harness-detail-version {
    display: none;
  }
  .harness-detail-overview {
    grid-template-columns: 1fr;
  }
  .harness-detail-side,
  .harness-current-side {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-version-controls {
    grid-template-columns: minmax(180px, 0.45fr) minmax(0, 1.4fr);
  }
  .harness-version-same-condition {
    grid-column: 1/-1;
    height: auto;
    min-height: 52px;
    align-self: stretch;
    padding-block: 9px;
  }
  .harness-version-metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-version-comparison-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 700px) {
  .harness-edit-backdrop {
    padding: 12px;
  }
  .harness-edit-modal {
    width: 100%;
    max-height: calc(100vh - 24px);
  }
  .harness-edit-modal > header,
  .harness-edit-modal > main,
  .harness-edit-modal > footer {
    padding-inline: 18px;
  }
  .harness-edit-fields {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 860px) {
  .harness-detail-header {
    position: relative;
  }
  .harness-detail-header__inner {
    align-items: flex-start;
  }
  .harness-detail-title-group p,
  .harness-detail-status {
    display: none;
  }
  .harness-detail-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-detail-summary article:nth-child(2) {
    border-right: 0;
  }
  .harness-detail-summary article:nth-child(3),
  .harness-detail-summary article:nth-child(4) {
    border-top: 1px solid #e5e7ea;
  }
  .harness-detail-summary article:nth-child(4) {
    border-right: 0;
  }
  .harness-current-version__facts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .harness-current-version__facts > div:nth-child(3) {
    border-right: 0;
  }
  .harness-current-version__facts > div:nth-child(n+4) {
    border-top: 1px solid #e7e9ec;
  }
  .harness-history-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-history-summary article:nth-child(2) {
    border-right: 0;
  }
  .harness-history-summary article:nth-child(n+3) {
    border-top: 1px solid #e7e9ec;
  }
  .harness-version-pair {
    grid-template-columns: 1fr;
  }
  .harness-version-pair > div i {
    transform: rotate(90deg);
  }
  .harness-version-score-comparison {
    grid-template-columns: 1fr;
  }
  .harness-detail-readiness ol,
  .harness-detail-performance__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-detail-readiness li:nth-child(2),
  .harness-detail-performance__grid article:nth-child(2) {
    border-right: 0;
  }
  .harness-detail-readiness li:nth-child(3),
  .harness-detail-readiness li:nth-child(4),
  .harness-detail-performance__grid article:nth-child(3),
  .harness-detail-performance__grid article:nth-child(4) {
    border-top: 1px solid #e7e9ec;
  }
  .harness-detail-readiness li:nth-child(4),
  .harness-detail-performance__grid article:nth-child(4) {
    border-right: 0;
  }
}
@media (max-width: 620px) {
  .harness-detail-header__inner {
    gap: 12px;
  }
  .harness-detail-title-group {
    gap: 10px;
  }
  .harness-detail-title-group h1 {
    max-width: 52vw;
  }
  .harness-detail-header__actions button {
    width: 40px;
    padding: 0;
    justify-content: center;
  }
  .harness-detail-header__actions button span {
    display: none;
  }
  .harness-detail-tabs {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .harness-detail-tabs button {
    min-width: 0;
  }
  .harness-current-binding-filter {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-current-binding-filter button {
    width: 100%;
  }
  .harness-history-summary {
    grid-template-columns: 1fr;
  }
  .harness-history-summary article,
  .harness-history-summary article:nth-child(2) {
    border-right: 0;
    border-bottom: 1px solid #e7e9ec;
  }
  .harness-history-summary article:last-child {
    border-bottom: 0;
  }
  .harness-history-footer {
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding-block: 10px;
  }
  .harness-version-controls {
    grid-template-columns: 1fr;
  }
  .harness-version-controls__selectors {
    grid-template-columns: 1fr;
  }
  .harness-version-swap {
    width: 100%;
  }
  .harness-version-swap i {
    transform: rotate(90deg);
  }
  .harness-version-same-condition {
    grid-column: auto;
  }
  .harness-version-condition-notice,
  .harness-version-metric-table,
  .harness-version-change-card,
  .harness-version-condition-card,
  .harness-version-score-card,
  .harness-version-failure-card {
    margin-inline: 12px;
  }
  .harness-version-pair {
    padding-inline: 12px;
  }
  .harness-version-metric-table {
    overflow-x: auto;
  }
  .harness-version-metric-grid {
    grid-template-columns: 1fr;
  }
  .harness-version-condition-table {
    overflow-x: auto;
  }
  .harness-version-condition-table > header,
  .harness-version-condition-table > article {
    min-width: 620px;
  }
  .harness-version-rule-groups,
  .harness-version-failure-groups {
    grid-template-columns: 1fr;
  }
  .harness-version-rule-groups > article,
  .harness-version-failure-groups > article {
    border-right: 1px solid #e1e4e6;
    border-bottom: 1px solid #e1e4e6;
  }
  .harness-version-rule-groups > article:last-child,
  .harness-version-failure-groups > article:last-child {
    border-bottom: 1px solid #e1e4e6;
  }
  .harness-version-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .harness-version-actions > div:last-child {
    display: grid;
    grid-template-columns: 1fr;
  }
  .harness-current-binding-list__head {
    display: none;
  }
  .harness-current-binding-list article {
    grid-template-columns: 105px minmax(0, 1fr) auto;
    gap: 8px 10px;
    padding-block: 12px;
  }
  .harness-current-binding-list__type {
    grid-column: 1;
    grid-row: 1/3;
  }
  .harness-current-binding-list__subject {
    grid-column: 2/4;
  }
  .harness-current-binding-list__version {
    grid-column: 2;
  }
  .harness-current-binding-list__status {
    grid-column: 3;
  }
  .harness-current-binding-list article > button {
    grid-column: 2/4;
    width: 100%;
  }
  .harness-current-binding-list__readonly {
    grid-column: 2/4;
    width: 100%;
  }
  .harness-connection-backdrop {
    padding: 14px;
  }
  .harness-connection-modal {
    width: calc(100vw - 28px);
    max-height: calc(100vh - 28px);
  }
  .harness-connection-modal > header {
    padding: 21px 18px 18px;
  }
  .harness-connection-modal > main {
    padding: 14px;
  }
  .harness-connection-option {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .harness-connection-option > i {
    width: 34px;
    height: 34px;
  }
  .harness-connection-option em {
    grid-column: 2;
    justify-self: start;
  }
  .harness-detail-summary,
  .harness-detail-readiness ol,
  .harness-detail-performance__grid,
  .harness-detail-side,
  .harness-current-side {
    grid-template-columns: 1fr;
  }
  .harness-current-version__body {
    grid-template-columns: 1fr;
  }
  .harness-current-version__facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .harness-current-version__facts > div,
  .harness-current-version__facts > div:nth-child(3) {
    border-right: 1px solid #e7e9ec;
  }
  .harness-current-version__facts > div:nth-child(even) {
    border-right: 0;
  }
  .harness-current-version__facts > div:nth-child(n+3) {
    border-top: 1px solid #e7e9ec;
  }
  .harness-current-resource-grid,
  .harness-current-projects {
    grid-template-columns: 1fr;
  }
  .harness-current-resource > header {
    grid-template-columns: 36px minmax(0, 1fr);
  }
  .harness-current-resource > header em {
    grid-column: 2;
    justify-self: start;
  }
  .harness-detail-summary article,
  .harness-detail-readiness li,
  .harness-detail-performance__grid article {
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid #e5e7ea;
    box-shadow: none;
  }
  .harness-detail-summary article:last-child,
  .harness-detail-readiness li:last-child,
  .harness-detail-performance__grid article:last-child {
    border-bottom: 0;
  }
  .harness-detail-card > header {
    align-items: flex-start;
    flex-direction: column;
  }
  .harness-detail-version-list article {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .harness-detail-version-list dl {
    grid-column: 2;
  }
}
@media (max-width: 700px) {
  .harness-readonly-summary {
    grid-template-columns: 1fr;
  }
  .harness-readonly-summary article {
    min-height: 94px;
    padding: 18px;
  }
  .harness-readonly-rules > header,
  .harness-readonly-rules li {
    padding-inline: 18px;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .harness-detail-page .harness-detail-content {
  width: 100%;
  max-width: 1600px;
  padding: 24px var(--ro-gutter) 48px;
  margin: 0 auto;
}
:host-context(.reviewops-shell) .harness-detail-page .harness-readonly-rules, :host-context(.reviewops-shell) .harness-detail-page .harness-detail-card {
  padding: 24px;
}
:host-context(.reviewops-shell) .harness-detail-page .harness-detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
:host-context(.reviewops-shell) .harness-detail-page .harness-detail-tabs button.is-active {
  color: #8F351D;
  background: #FFF0ED;
  border-color: var(--ro-accent);
}
:host-context(.reviewops-shell) .harness-detail-page .harness-readonly-summary {
  gap: 16px;
  margin-bottom: 24px;
}
:host-context(.reviewops-shell) .harness-detail-page .harness-version-failure-card, :host-context(.reviewops-shell) .harness-detail-page .harness-version-score-card {
  overflow: auto;
}
@media (max-width: 639px) {
  :host-context(.reviewops-shell) .harness-detail-page .harness-readonly-rules, :host-context(.reviewops-shell) .harness-detail-page .harness-detail-card {
    padding: 16px;
  }
}`],
})
export class PageHarnessesItemComponent implements OnInit {
    public harnessId: string = '';
    public harness: any = null;
    public readOnlyMode: boolean = false;
    public tab: string = 'overview';
    public bindingFilter: string = 'all';
    public expandedHistoryId: string = '';
    public evaluationRulesExpanded: boolean = false;
    public baseVersionId: string = '';
    public compareVersionId: string = '';
    public openVersionSelector: string = '';
    public sameConditionOnly: boolean = false;
    public expandedRuleChangeGroups: Record<string, boolean> = {
        added: false,
        modified: false,
        removed: false
    };
    public loadError: string = '';
    public showEditModal: boolean = false;
    public savingEdit: boolean = false;
    public connectionModalType: string = '';
    public connectingResourceId: string = '';
    public editForm: any = { name: '', category: '공통', threshold: 90, rulesText: '' };
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly workspaceManagementUrl: string = '/api/v1/review-workspace/management';
    private workspaceState: any = null;
    private workspaceStateLoaded: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        this.readOnlyMode = this.readOnlyRequested();
        this.harnessId = WizRoute.segment.id || '';
        await this.loadWorkspaceHarness();
        await this.service.render();
    }

    private readOnlyRequested() {
        if (typeof window === 'undefined') return false;
        const params = new URLSearchParams(window.location.search || '');
        return params.get('readonly') === '1';
    }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async fetchWorkspaceState() {
        const response = await fetch(this.workspaceStateUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
        const payload = await response.json();
        const state = this.normalizeWorkspaceState(payload);
        if (!state || !Array.isArray(state.harnesses)) {
            throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        }
        return state;
    }

    private async mutateWorkspace(request: any) {
        if (this.readOnlyMode) throw new Error('읽기 전용 하네스는 변경할 수 없습니다.');
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.workspaceManagementUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        const responseCode = Number(payload?.code || payload?.status || response.status);
        const responseMessage = payload?.message || payload?.data?.message || payload?.error?.message;
        if (!response.ok || responseCode >= 400) {
            throw new Error(responseMessage || '하네스를 수정하지 못했습니다.');
        }
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        const result = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && candidate.state && typeof candidate.state === 'object');
        const state = this.normalizeWorkspaceState({ state: result?.state });
        if (!result || !state || !result.item) throw new Error('하네스 수정 응답이 올바르지 않습니다.');
        return { ...result, state };
    }

    private numericValue(...values: any[]) {
        for (const value of values) {
            if (value === null || value === undefined || value === '') continue;
            const numeric = Number(value);
            if (Number.isFinite(numeric)) return numeric;
        }
        return null;
    }

    private normalizeHarnessVersion(version: any, activeVersion: string) {
        const versionId = String(version?.version || version?.id || version?.name || '');
        return {
            ...version,
            version: versionId,
            date: version?.date || version?.createdAt || version?.created_at || '—',
            author: version?.author || version?.owner || '미지정',
            passRate: this.numericValue(version?.passRate, version?.pass_rate, version?.score) || 0,
            delta: version?.delta ?? '-',
            note: version?.note || version?.description || '',
            rules: Array.isArray(version?.rules) ? version.rules : [],
            active: version?.active !== undefined ? !!version.active : versionId === activeVersion
        };
    }

    private normalizeServerHarness(row: any) {
        const declaredActive = String(row?.version || row?.activeVersion || row?.active_version || '');
        const versions = (Array.isArray(row?.versions) ? row.versions : [])
            .map((version: any) => this.normalizeHarnessVersion(version, declaredActive));
        const active = versions.find((version: any) => version.active)
            || versions.find((version: any) => version.version === declaredActive)
            || versions[0]
            || null;
        if (active && !versions.some((version: any) => version.active)) active.active = true;
        const bindings = Array.isArray(row?.bindings) ? row.bindings : (row?.bindings || []);
        const history = Array.isArray(row?.testRuns)
            ? row.testRuns
            : (Array.isArray(row?.test_runs) ? row.test_runs : (Array.isArray(row?.history) ? row.history : []));
        const projectItems = Array.isArray(row?.projects) ? row.projects : [];
        const boundProjectCount = Array.isArray(bindings)
            ? new Set(bindings
                .filter((binding: any) => this.bindingKind(binding) === '프로젝트')
                .map((binding: any) => String(binding?.id || binding?.projectId || binding?.project_id || ''))
                .filter(Boolean)).size
            : 0;
        const projectCount = projectItems.length
            ? projectItems.length
            : Math.max(this.numericValue(row?.projects, row?.projectCount, row?.project_count) || 0, boundProjectCount);
        const passRate = this.numericValue(row?.passRate, row?.pass_rate, row?.score, history[0]?.score, active?.passRate) || 0;
        const semantic = row?.semantic_review && typeof row.semantic_review === 'object'
            ? row.semantic_review
            : (row?.semanticReview && typeof row.semanticReview === 'object' ? row.semanticReview : {});
        return {
            ...row,
            id: String(row?.id || ''),
            name: row?.name || row?.title || '이름 없는 하네스',
            category: row?.category || '공통',
            version: active?.version || declaredActive || 'v1.0',
            status: row?.status || (passRate >= 90 ? '운영' : (passRate > 0 ? '검증 필요' : '초안')),
            owner: row?.owner || row?.author || '미지정',
            projects: projectCount,
            projectItems,
            passRate,
            delta: row?.delta ?? active?.delta ?? 0,
            updated: row?.updated || row?.updatedAt || row?.updated_at || active?.date || '—',
            versions,
            bindings,
            testRuns: history,
            history,
            notHumanReview: semantic?.not_human_review === true || semantic?.notHumanReview === true,
            aiQualityGateStatus: String(semantic?.ai_quality_gate_status || semantic?.aiQualityGateStatus || ''),
            humanReleaseStatus: String(semantic?.human_release_status || semantic?.humanReleaseStatus || '')
        };
    }

    private async loadWorkspaceHarness() {
        try {
            const state = await this.fetchWorkspaceState();
            this.workspaceState = state;
            this.workspaceStateLoaded = true;
            const row = state.harnesses.find((item: any) => String(item?.id || '') === String(this.harnessId));
            this.harness = row ? this.normalizeServerHarness(row) : null;
            this.loadError = '';
            this.initializeVersionComparison();
            return true;
        } catch (error) {
            this.harness = null;
            this.workspaceState = null;
            this.workspaceStateLoaded = false;
            this.loadError = error instanceof Error
                ? error.message
                : '하네스 상세를 불러오지 못했습니다.';
            return false;
        }
    }

    public async reloadWorkspaceHarness() {
        await this.loadWorkspaceHarness();
        await this.service.render();
    }

    private initializeVersionComparison() {
        const versions = this.versions();
        const current = versions.find((version: any) => version.active) || versions[0] || null;
        const currentIndex = versions.indexOf(current);
        const previous = currentIndex > 0
            ? versions[currentIndex - 1]
            : versions.find((version: any) => version !== current) || null;
        this.compareVersionId = current ? current.version : '';
        this.baseVersionId = previous ? previous.version : '';
    }

    public async goBack() {
        await this.router.navigate(['/harnesses']);
    }

    private markdownValue(value: any) {
        return String(value ?? '').replace(/\r\n?/g, '\n').trim();
    }

    private markdownTableCell(value: any) {
        return this.markdownValue(value)
            .replace(/\\/g, '\\\\')
            .replace(/\|/g, '\\|')
            .replace(/\n/g, '<br>') || '—';
    }

    private markdownFilePart(value: any) {
        const normalized = this.markdownValue(value).normalize('NFKC')
            .replace(/[\\/:*?"<>|%]/g, '-')
            .replace(/\s+/g, '_')
            .replace(/^\.+|\.+$/g, '')
            .slice(0, 80);
        return normalized || 'harness';
    }

    public buildHarnessMarkdown() {
        if (!this.harness) return '';
        const current = this.currentVersionData();
        const rules = this.currentRules();
        const bindings = this.currentBindings().filter((binding: any) => !binding?.empty);
        const versions = this.versions();
        const lines: string[] = [
            '---',
            'schema: "review-harness-markdown/1.0"',
            'harness_id: ' + JSON.stringify(String(this.harness.id || '')),
            'name: ' + JSON.stringify(String(this.harness.name || '')),
            'category: ' + JSON.stringify(String(this.harness.category || '공통')),
            'active_version: ' + JSON.stringify(String(this.harness.version || current?.version || '')),
            'status: ' + JSON.stringify(this.readinessLabel()),
            'pass_threshold: ' + String(this.passThreshold()),
            '---',
            '',
            '# ' + this.markdownValue(this.harness.name || this.harness.id || '검수 하네스'),
            '',
            '> 이 문서는 하네스 상세 화면의 현재 저장 상태에서 내보낸 Markdown 명세입니다.',
            '',
            '## 기본 정보',
            '',
            '| 항목 | 값 |',
            '| --- | --- |',
            '| 하네스 ID | ' + this.markdownTableCell(this.harness.id) + ' |',
            '| 분류 | ' + this.markdownTableCell(this.harness.category) + ' |',
            '| 현재 버전 | ' + this.markdownTableCell(this.harness.version || current?.version) + ' |',
            '| 준비 상태 | ' + this.markdownTableCell(this.readinessLabel()) + ' |',
            '| 통과 기준 | ' + this.markdownTableCell(this.passThreshold() + '점') + ' |',
            '| 현재 점수 | ' + this.markdownTableCell((Number(this.harness.passRate) || 0) + '점') + ' |',
            '| 담당자 | ' + this.markdownTableCell(this.harness.owner) + ' |',
            '| 마지막 수정 | ' + this.markdownTableCell(this.updatedDate()) + ' |',
            '',
            '## 현재 버전',
            '',
            '- 버전: `' + this.markdownValue(this.harness.version || current?.version || '—') + '`',
            '- 변경 내용: ' + this.markdownValue(this.currentVersionNote() || '기록 없음'),
            '',
            '## 평가 규칙',
            ''
        ];
        if (rules.length) {
            rules.forEach((rule: any, index: number) => {
                lines.push(String(index + 1) + '. ' + this.markdownValue(rule).replace(/\n/g, '  \n   '));
            });
        } else {
            lines.push('_등록된 평가 규칙이 없습니다._');
        }
        lines.push('', '## 연결 대상', '');
        if (bindings.length) {
            lines.push('| 유형 | 이름 | ID | 버전 | 상태 |', '| --- | --- | --- | --- | --- |');
            bindings.forEach((binding: any) => lines.push(
                '| ' + [
                    binding.kind,
                    binding.name,
                    binding.id,
                    binding.version,
                    binding.status
                ].map((value: any) => this.markdownTableCell(value)).join(' | ') + ' |'
            ));
        } else {
            lines.push('_연결된 대상이 없습니다._');
        }
        lines.push('', '## 버전 이력', '');
        if (versions.length) {
            lines.push('| 버전 | 날짜 | 작성자 | 점수 | 변화 | 설명 |', '| --- | --- | --- | ---: | ---: | --- |');
            versions.forEach((version: any) => lines.push(
                '| ' + [
                    version.version,
                    version.date,
                    version.author,
                    (Number(version.passRate) || 0) + '점',
                    version.delta ?? '—',
                    version.note || '—'
                ].map((value: any) => this.markdownTableCell(value)).join(' | ') + ' |'
            ));
        } else {
            lines.push('_저장된 버전 이력이 없습니다._');
        }
        return lines.join('\n') + '\n';
    }

    public async downloadHarnessMarkdown() {
        if (!this.harness) {
            await this.service.modal.warning('다운로드할 하네스를 찾을 수 없습니다.', false, '확인');
            return;
        }
        if (typeof document === 'undefined' || typeof URL === 'undefined' || typeof Blob === 'undefined') {
            await this.service.modal.warning('현재 환경에서는 파일을 다운로드할 수 없습니다.', false, '확인');
            return;
        }
        const markdown = this.buildHarnessMarkdown();
        const blob = new Blob(['\uFEFF', markdown], { type: 'text/markdown;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = [
            this.markdownFilePart(this.harness.name || this.harness.id),
            this.markdownFilePart(this.harness.version || 'current')
        ].join('_') + '.md';
        anchor.style.display = 'none';
        document.body.appendChild(anchor);
        try {
            anchor.click();
        } finally {
            anchor.remove();
            window.setTimeout(() => URL.revokeObjectURL(url), 0);
        }
    }

    public async setTab(tab: string) {
        this.tab = tab;
        await this.service.render();
    }

    public readinessLabel() {
        if (!this.harness) return '';
        if (
            this.harness.notHumanReview === true
            && this.harness.aiQualityGateStatus === 'passed'
            && this.harness.humanReleaseStatus === 'pending'
        ) return 'AI 품질 통과';
        const status = String(this.harness.status || '').toLowerCase();
        if (status.indexOf('운영') >= 0 || ['active', 'live', 'production'].indexOf(status) >= 0) return '운영 가능';
        if (this.harness.status === '실험' || this.harness.status === '검증 필요') return '검증 필요';
        if (Number(this.harness.passRate) >= 90) return '운영 가능';
        return '초안';
    }

    public readinessClass() {
        const label = this.readinessLabel();
        if (label === '운영 가능') return 'is-ready';
        if (label === '검증 필요' || label === 'AI 품질 통과') return 'is-review';
        return 'is-draft';
    }

    private bindingKind(binding: any) {
        const value = String(
            binding?.kind || binding?.type || binding?.resourceType || binding?.resource_type || binding?.entity || ''
        ).toLowerCase();
        if (value.indexOf('survey') >= 0 || value.indexOf('설문') >= 0) return '설문지';
        if (value.indexOf('project') >= 0 || value.indexOf('프로젝트') >= 0) return '프로젝트';
        if (value.indexOf('dataset') >= 0 || value.indexOf('데이터셋') >= 0) return '데이터셋';
        return '';
    }

    private normalizeBinding(binding: any, forcedKind: string = '') {
        if (typeof binding === 'string') {
            const registry = forcedKind === '프로젝트'
                ? this.workspaceState?.projects
                : (forcedKind === '설문지' ? this.workspaceState?.surveys : []);
            const resolved = Array.isArray(registry)
                ? registry.find((item: any) => String(item?.id || '') === binding || String(item?.name || '') === binding)
                : null;
            binding = resolved || { id: binding, name: binding };
        }
        const kind = forcedKind || this.bindingKind(binding);
        const id = binding?.id || binding?.resourceId || binding?.resource_id || binding?.projectId
            || binding?.project_id || binding?.surveyId || binding?.survey_id || binding?.datasetId || binding?.dataset_id || '-';
        const name = binding?.name || binding?.title || binding?.label || (kind === '프로젝트'
            ? '연결된 프로젝트'
            : (kind === '설문지' ? '연결된 설문지' : '연결된 데이터셋'));
        return {
            ...binding,
            kind,
            icon: kind === '프로젝트' ? 'fa-diagram-project' : (kind === '설문지' ? 'fa-file-lines' : 'fa-database'),
            id: String(id),
            name,
            version: binding?.version || binding?.activeVersion || binding?.active_version || '현재',
            status: binding?.status || '적용 중',
            route: kind === '설문지'
                ? ['/surveys']
                : (kind === '프로젝트' && id !== '-' ? ['/review-projects', String(id)] : ['/review-projects'])
        };
    }

    private projectUsesHarness(project: any) {
        const settings = project?.settings || {};
        const values = [
            project?.harness,
            project?.harnessId,
            project?.harness_id,
            settings?.qa?.harness,
            settings?.qa?.harnessId,
            settings?.qa?.harness_id,
            settings?.kg?.harness,
            settings?.kg?.harnessId,
            settings?.kg?.harness_id
        ].filter(Boolean).map((value: any) => String(value));
        return values.indexOf(String(this.harness?.id || '')) >= 0
            || values.indexOf(String(this.harness?.name || '')) >= 0;
    }

    private projectDatasetBindings(project: any) {
        const datasets: any[] = [];
        const add = (value: any) => {
            if (Array.isArray(value)) {
                value.forEach(add);
                return;
            }
            if (!value) return;
            const raw = typeof value === 'string' ? { id: value, name: value } : value;
            if (!raw || typeof raw !== 'object') return;
            const id = raw.id || raw.datasetId || raw.dataset_id;
            const name = raw.name || raw.datasetName || raw.dataset_name || raw.title;
            if (!id && !name) return;
            const normalized = this.normalizeBinding({
                ...raw,
                id: id || name,
                name: name || id,
                version: raw.version || raw.datasetVersion || raw.dataset_version || '현재',
                status: raw.status || '프로젝트 자동 연결'
            }, '데이터셋');
            if (!datasets.some((dataset: any) => dataset.id === normalized.id)) datasets.push(normalized);
        };
        [
            project?.datasets,
            project?.dataset,
            project?.datasetBindings,
            project?.dataset_bindings,
            project?.qa?.datasets,
            project?.qa?.dataset,
            project?.kg?.datasets,
            project?.kg?.dataset,
            project?.settings?.qa?.datasets,
            project?.settings?.qa?.dataset,
            project?.settings?.kg?.datasets,
            project?.settings?.kg?.dataset
        ].forEach(add);
        if (project?.datasetId || project?.dataset_id || project?.datasetName || project?.dataset_name) add(project);

        if (!datasets.length) {
            const settings = project?.settings && typeof project.settings === 'object' ? project.settings : {};
            const sourceSignatures = new Set<string>();
            ['qa', 'kg'].forEach((kind: string) => {
                const setting = settings[kind];
                if (!setting || typeof setting !== 'object') return;
                const source = String(setting.source || '').trim();
                if (!source || source === '미설정') return;
                const scope = String(setting.sourceScope || 'all');
                const scopeValue = scope === 'category'
                    ? String(setting.sourceCategory || '').trim()
                    : (scope === 'collection' ? String(setting.sourceCollection || '').trim() : '전체 자료');
                const signature = [source, scope, scopeValue].join('|');
                if (sourceSignatures.has(signature)) return;
                sourceSignatures.add(signature);
                const sourceLabel = sourceSignatures.size === 1
                    && project?.sourceLabel
                    && !String(project.sourceLabel).includes('미설정')
                    ? String(project.sourceLabel)
                    : [source, scopeValue].filter(Boolean).join(' · ');
                datasets.push(this.normalizeBinding({
                    id: `${project.id}-SOURCE-${sourceSignatures.size}`,
                    name: sourceLabel,
                    version: '현재',
                    status: '프로젝트 자동 연결',
                    description: `${project.name} 프로젝트의 자료 범위`
                }, '데이터셋'));
            });
        }
        return datasets;
    }

    private serverBindings() {
        if (!this.workspaceStateLoaded || !this.harness) return [];
        const raw = this.harness.bindings;
        const rows: any[] = [];
        if (Array.isArray(raw)) {
            raw.forEach((binding: any) => {
                const normalized = this.normalizeBinding(binding);
                if (normalized.kind) rows.push(normalized);
            });
        } else if (raw && typeof raw === 'object') {
            const datasets = Array.isArray(raw.datasets) ? raw.datasets : (raw.dataset ? [raw.dataset] : []);
            const surveys = Array.isArray(raw.surveys) ? raw.surveys : (raw.survey ? [raw.survey] : []);
            const projects = Array.isArray(raw.projects) ? raw.projects : (raw.project ? [raw.project] : []);
            datasets.forEach((binding: any) => rows.push(this.normalizeBinding(binding, '데이터셋')));
            surveys.forEach((binding: any) => rows.push(this.normalizeBinding(binding, '설문지')));
            projects.forEach((binding: any) => rows.push(this.normalizeBinding(binding, '프로젝트')));
        }

        if (!rows.some((binding: any) => binding.kind === '설문지')) {
            const surveyBinding = this.harness?.survey || this.harness?.surveyId || this.harness?.survey_id;
            if (surveyBinding) rows.push(this.normalizeBinding(surveyBinding, '설문지'));
        }
        if (!rows.some((binding: any) => binding.kind === '데이터셋')) {
            const datasetBinding = this.harness?.dataset || this.harness?.datasetId || this.harness?.dataset_id;
            if (datasetBinding) rows.push(this.normalizeBinding(datasetBinding, '데이터셋'));
        }
        const projectItems = Array.isArray(this.harness?.projectItems) ? this.harness.projectItems : [];
        projectItems.forEach((binding: any) => {
            const normalized = this.normalizeBinding(binding, '프로젝트');
            if (!rows.some((item: any) => item.kind === '프로젝트' && item.id === normalized.id)) rows.push(normalized);
        });

        const existingProjectIds = new Set(rows
            .filter((binding: any) => binding.kind === '프로젝트')
            .map((binding: any) => String(binding.id)));
        const projects = Array.isArray(this.workspaceState?.projects) ? this.workspaceState.projects : [];
        projects.filter((project: any) => this.projectUsesHarness(project)).forEach((project: any) => {
            if (existingProjectIds.has(String(project?.id || ''))) return;
            rows.push(this.normalizeBinding({
                id: project?.id,
                name: project?.name || project?.title,
                version: project?.harnessVersion || project?.harness_version || this.harness.version,
                status: project?.status || '운영 적용'
            }, '프로젝트'));
        });

        const connectedProjectIds = new Set(rows
            .filter((binding: any) => binding.kind === '프로젝트')
            .map((binding: any) => String(binding.id)));
        projects.filter((project: any) => connectedProjectIds.has(String(project?.id || '')))
            .forEach((project: any) => this.projectDatasetBindings(project).forEach((dataset: any) => {
                if (!rows.some((binding: any) => binding.kind === '데이터셋' && binding.id === dataset.id)) {
                    rows.push(dataset);
                }
            }));

        return rows;
    }

    private currentStateProfiles() {
        return {
            'HN-001': {
                dataset: { id: 'DS-KG-001', name: '동북아 역사 지식그래프 생성 데이터셋', version: 'v1.0', status: '적용 중' },
                survey: { id: 'SV-NEAHF-003', name: '독도 관련 사료 지식그래프 관계 검수서', version: 'v0.8', status: '적용 중' },
                projects: []
            },
            'HN-002': {
                dataset: { id: 'DS-QA-002', name: '동북아 역사 QA 대표 데이터셋', version: 'v2.0', status: '적용 중' },
                survey: { id: 'SV-NEAHF-001', name: '동북아 역사 QA·지식그래프 대표 표본 검수서', version: 'v1.0', status: '적용 중' },
                projects: [
                    { id: 'RV-2026-017', name: '동북아 역사 QA 구축', status: '운영 적용' },
                    { id: 'RV-2026-021', name: '근현대 외교 문서 QA', status: '운영 적용' }
                ]
            },
            'HN-003': {
                dataset: { id: 'DS-EV-003', name: '사료 근거 추적 검증 데이터셋', version: 'v0.8', status: '적용 중' },
                survey: { id: 'SV-NEAHF-005', name: '사료 근거·인용 일치성 검수서', version: 'v0.4', status: '적용 중' },
                projects: [
                    { id: 'RV-2026-018', name: '사료 근거 추적 검증', status: '검증 적용' }
                ]
            },
            'HN-004': {
                dataset: { id: 'DS-KG-004', name: '역사 인물 관계 추출 데이터셋', version: 'v0.4', status: '검증 준비' },
                survey: { id: 'SV-NEAHF-004', name: '동북아 인물·기관 엔터티 검수서', version: 'v1.1', status: '검증 준비' },
                projects: []
            }
        } as any;
    }

    private currentStateProfile() {
        if (this.workspaceStateLoaded) {
            const bindings = this.serverBindings();
            const datasets = bindings.filter((binding: any) => binding.kind === '데이터셋');
            return {
                datasets,
                dataset: datasets[0] || {
                    id: '-', name: '연결된 데이터셋이 없습니다.', version: '-', status: '자동 연결', empty: true,
                    description: '프로젝트를 연결하면 프로젝트의 데이터셋이 자동으로 연결됩니다.'
                },
                survey: bindings.find((binding: any) => binding.kind === '설문지') || {
                    id: '-', name: '연결된 설문지가 없습니다.', version: '-', status: '연결 필요', empty: true
                },
                projects: bindings.filter((binding: any) => binding.kind === '프로젝트')
            };
        }
        const profiles = this.currentStateProfiles();
        const profile = profiles[this.harnessId] || {
            dataset: { id: '-', name: '연결된 데이터셋이 없습니다.', version: '-', status: '연결 필요' },
            survey: { id: '-', name: '연결된 설문지가 없습니다.', version: '-', status: '연결 필요' },
            projects: []
        };
        return {
            ...profile,
            datasets: Array.isArray(profile.datasets) ? profile.datasets : [profile.dataset]
        };
    }

    public currentVersionData() {
        const versions = this.versions();
        return versions.find((version: any) => version.active) || versions[0] || {
            version: this.harness?.version || '-',
            note: '현재 버전의 변경 내용이 기록되지 않았습니다.',
            passRate: Number(this.harness?.passRate) || 0,
            delta: '-'
        };
    }

    public previousVersionData() {
        const current = this.currentVersionData();
        return this.versions().find((version: any) => version !== current && !version.active) || null;
    }

    public currentVersionNote() {
        return this.currentVersionData().note || '현재 버전의 변경 내용이 기록되지 않았습니다.';
    }

    public scoreComparison() {
        const currentScore = Number(this.harness?.passRate) || 0;
        const previous = this.previousVersionData();
        const previousScore = Number(previous?.passRate) || 0;
        if (previous && previousScore > 0) return previousScore + '점 → ' + currentScore + '점';
        if (currentScore > 0) return currentScore + '점';
        return '첫 시험 전';
    }

    public deltaLabel() {
        const delta = Number(this.harness?.delta) || 0;
        if (delta > 0) return '+' + delta + '점 개선';
        if (delta < 0) return Math.abs(delta) + '점 하락';
        return '비교 결과 없음';
    }

    public passThreshold() {
        const threshold = this.numericValue(
            this.harness?.threshold, this.harness?.target, this.harness?.targetScore, this.harness?.target_score
        );
        return threshold === null ? 90 : threshold;
    }

    public currentRules() {
        if (!this.harness) return [];
        const activeRules = this.currentVersionData()?.rules;
        if (Array.isArray(activeRules) && activeRules.length) return activeRules;
        if (Array.isArray(this.harness.rules)) return this.harness.rules;
        return Array.isArray(activeRules) ? activeRules : [];
    }

    public ruleCount() {
        return this.currentRules().length;
    }

    public updatedDate() {
        return this.calendarDate(this.harness?.updated);
    }

    public latestTestDate() {
        return this.calendarDate(this.latestTestHistory()?.date);
    }

    private calendarDate(rawValue: any) {
        const value = String(rawValue || '').trim();
        const calendarDate = value.match(/^\d{4}-\d{2}-\d{2}/);
        if (calendarDate) return calendarDate[0];
        const date = new Date(value);
        return value && !Number.isNaN(date.getTime()) ? date.toISOString().slice(0, 10) : (value || '—');
    }

    public async toggleEvaluationRules() {
        this.tab = 'overview';
        this.evaluationRulesExpanded = !this.evaluationRulesExpanded;
        await this.service.render();
        if (this.evaluationRulesExpanded && typeof document !== 'undefined') {
            document.querySelector('#harness-rule-list')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    public async openEdit() {
        if (this.readOnlyMode) return;
        this.editForm = {
            name: this.harness?.name || '',
            category: this.harness?.category || '공통',
            threshold: this.passThreshold(),
            rulesText: this.currentRules().join('\n')
        };
        this.showEditModal = true;
        await this.service.render();
    }

    public async closeEdit() {
        if (this.savingEdit) return;
        this.showEditModal = false;
        await this.service.render();
    }

    public async saveHarness() {
        if (this.readOnlyMode) return;
        const name = String(this.editForm.name || '').trim();
        const threshold = Number(this.editForm.threshold);
        if (!name) {
            await this.service.modal.warning('하네스 이름을 입력해주세요.', false, '확인');
            return;
        }
        if (!Number.isFinite(threshold) || threshold < 0 || threshold > 100) {
            await this.service.modal.warning('통과 기준 점수는 0에서 100 사이로 입력해주세요.', false, '확인');
            return;
        }
        const rules = Array.from(new Set(String(this.editForm.rulesText || '')
            .split(/\r?\n/)
            .map((rule: string) => rule.trim())
            .filter(Boolean)));
        const active = this.currentVersionData();
        let versions = this.versions().map((version: any) => ({
            ...version,
            rules: version === active || version.version === active.version ? rules : (version.rules || [])
        }));
        if (!versions.length) {
            versions = [{
                version: this.harness?.version || 'v0.1',
                date: new Date().toISOString(),
                author: this.harness?.owner || '미지정',
                note: '하네스 수정',
                passRate: Number(this.harness?.passRate) || 0,
                delta: '-',
                rules,
                active: true
            }];
        }
        this.savingEdit = true;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'harnesses',
                action: 'update',
                id: this.harness.id,
                patch: { name, category: this.editForm.category, target: threshold, versions }
            });
            this.workspaceState = result.state;
            this.workspaceStateLoaded = true;
            this.harness = this.normalizeServerHarness(result.item);
            this.initializeVersionComparison();
            this.showEditModal = false;
            await this.service.modal.success('하네스를 수정했습니다.');
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '하네스를 수정하지 못했습니다.', false, '확인'
            );
        } finally {
            this.savingEdit = false;
            await this.service.render();
        }
    }

    public currentBindings() {
        const profile = this.currentStateProfile();
        const datasets = Array.isArray(profile.datasets) && profile.datasets.length
            ? profile.datasets
            : [profile.dataset];
        const bindings: any[] = datasets.map((dataset: any) => ({
                kind: '데이터셋', icon: 'fa-database', ...profile.dataset,
                ...dataset,
                route: dataset.route || ['/review-projects']
            }));
        bindings.push(
            {
                kind: '설문지', icon: 'fa-file-lines', ...profile.survey,
                route: profile.survey.route || ['/surveys']
            }
        );

        if (profile.projects.length) {
            profile.projects.forEach((project: any) => bindings.push({
                kind: '프로젝트', icon: 'fa-diagram-project', version: '현재',
                route: project.route || ['/review-projects', project.id], ...project
            }));
        } else {
            bindings.push({
                kind: '프로젝트', icon: 'fa-diagram-project', id: '-',
                name: '연결된 프로젝트가 없습니다.', version: '-', status: '미적용',
                route: ['/review-projects'], empty: true
            });
        }

        return bindings;
    }

    public currentDataset() {
        return this.currentDatasets()[0];
    }

    public currentDatasets() {
        return this.currentBindings().filter((binding: any) => binding.kind === '데이터셋');
    }

    public currentSurvey() {
        return this.currentBindings().find((binding: any) => binding.kind === '설문지');
    }

    public currentProjectBindings() {
        return this.currentBindings().filter((binding: any) => binding.kind === '프로젝트');
    }

    public currentProjectCount() {
        return this.currentProjectBindings().filter((binding: any) => !binding.empty).length;
    }

    public currentBindingCount(filter: string) {
        const datasetCount = this.currentDatasets().filter((binding: any) => !binding.empty).length;
        const projectCount = this.currentProjectCount();
        if (filter === 'dataset') return datasetCount;
        if (filter === 'survey') return this.currentSurvey()?.empty ? 0 : 1;
        if (filter === 'project') return projectCount;
        return datasetCount + (this.currentSurvey()?.empty ? 0 : 1) + projectCount;
    }

    public async setBindingFilter(filter: string) {
        this.bindingFilter = filter;
        await this.service.render();
    }

    public visibleBindings() {
        if (this.bindingFilter === 'all') return this.currentBindings();
        const kindMap: any = {
            dataset: '데이터셋',
            survey: '설문지',
            project: '프로젝트'
        };
        return this.currentBindings().filter((binding: any) => binding.kind === kindMap[this.bindingFilter]);
    }

    public bindingActionLabel(binding: any) {
        if (binding?.kind === '데이터셋') return binding?.empty ? '연결하기' : '연결 안내';
        if (binding?.empty) return '연결하기';
        return binding?.kind === '설문지' ? '변경하기' : '연결 관리';
    }

    public async openConnectionModal(binding: any) {
        if (this.readOnlyMode) return;
        if (!binding) return;
        if (binding.kind === '데이터셋') {
            await this.service.modal.info('프로젝트를 연결하면 자동으로 연결됩니다.');
            return;
        }
        this.connectionModalType = binding.kind === '설문지' ? 'survey' : 'project';
        await this.service.render();
    }

    public async closeConnectionModal() {
        if (this.connectingResourceId) return;
        this.connectionModalType = '';
        await this.service.render();
    }

    public connectionModalTitle() {
        return this.connectionModalType === 'survey' ? '설문지 연결' : '프로젝트 연결';
    }

    public connectionModalDescription() {
        return this.connectionModalType === 'survey'
            ? '이 하네스에 적용할 설문지를 선택해주세요.'
            : '이 하네스를 사용할 프로젝트를 선택해주세요. 프로젝트의 데이터셋도 자동으로 연결됩니다.';
    }

    public availableConnectionItems() {
        if (this.connectionModalType === 'survey') {
            return Array.isArray(this.workspaceState?.surveys) ? this.workspaceState.surveys : [];
        }
        return Array.isArray(this.workspaceState?.projects) ? this.workspaceState.projects : [];
    }

    public connectionItemVersion(item: any) {
        if (this.connectionModalType === 'project') {
            const outputs = item?.outputs || {};
            const labels = [outputs.qa ? 'QA' : '', outputs.kg ? 'KG' : ''].filter(Boolean);
            return labels.length ? labels.join(' · ') : (item?.lifecycle || '프로젝트');
        }
        const versions = Array.isArray(item?.versions) ? item.versions : [];
        const active = versions.find((version: any) => version?.active === true) || versions[0] || {};
        return item?.activeVersion || item?.active_version || item?.version || active?.version || active?.id || '현재';
    }

    public isConnectionItemConnected(item: any) {
        const kind = this.connectionModalType === 'survey' ? '설문지' : '프로젝트';
        return this.serverBindings().some((binding: any) => binding.kind === kind && String(binding.id) === String(item?.id || ''));
    }

    private persistedHarnessBindings() {
        const bindings: any[] = [];
        const raw = Array.isArray(this.harness?.bindings) ? this.harness.bindings : [];
        raw.map((binding: any) => this.normalizeBinding(binding))
            .filter((binding: any) => binding.kind && binding.id && binding.id !== '-')
            .forEach((binding: any) => {
                const item = {
                    id: String(binding.id),
                    kind: binding.kind,
                    name: String(binding.name || binding.id),
                    version: String(binding.version || '현재'),
                    status: String(binding.status || '적용 중')
                };
                if (!bindings.some((current: any) => current.kind === item.kind && current.id === item.id)) bindings.push(item);
            });
        return bindings;
    }

    private async persistHarnessBindings(bindings: any[], resourceId: string, successMessage: string) {
        if (this.readOnlyMode) return;
        this.connectingResourceId = resourceId;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'harnesses', action: 'update', id: this.harness.id, patch: { bindings }
            });
            this.workspaceState = result.state;
            this.workspaceStateLoaded = true;
            this.harness = this.normalizeServerHarness(result.item);
            this.connectionModalType = '';
            await this.service.render();
            await this.service.modal.success(successMessage);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '연결 정보를 저장하지 못했습니다.', false, '확인'
            );
        } finally {
            this.connectingResourceId = '';
            await this.service.render();
        }
    }

    public async connectProject(project: any) {
        if (this.readOnlyMode) return;
        if (!project || this.isConnectionItemConnected(project)) return;
        const settings = JSON.parse(JSON.stringify(project?.settings || {}));
        const outputs = project?.outputs || {};
        ['qa', 'kg'].forEach((kind: string) => {
            if (!outputs[kind] && !settings[kind]) return;
            const defaults: any = {
                source: '', survey: '', target: this.passThreshold(), maxRounds: 3
            };
            if (kind === 'qa') defaults.targetQaCount = 15;
            settings[kind] = {
                ...defaults,
                ...(settings[kind] && typeof settings[kind] === 'object' ? settings[kind] : {}),
                harness: this.harness.name,
                harnessId: this.harness.id,
                harnessVersion: this.harness.version
            };
        });
        this.connectingResourceId = String(project.id);
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'projects', action: 'update', id: project.id,
                patch: { settings, harness: this.harness.name, updatedRelative: '방금 전' }
            });
            this.workspaceState = result.state;
            this.workspaceStateLoaded = true;
            const currentHarness = result.state.harnesses.find((item: any) => String(item?.id || '') === String(this.harness.id));
            if (currentHarness) this.harness = this.normalizeServerHarness(currentHarness);
            this.connectionModalType = '';
            await this.service.render();
            await this.service.modal.success(project.name + ' 프로젝트를 연결했습니다.');
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '프로젝트를 연결하지 못했습니다.', false, '확인'
            );
        } finally {
            this.connectingResourceId = '';
            await this.service.render();
        }
    }

    public async connectSurvey(survey: any) {
        if (this.readOnlyMode) return;
        if (!survey || this.isConnectionItemConnected(survey)) return;
        const bindings = this.persistedHarnessBindings().filter((binding: any) => binding.kind !== '설문지');
        bindings.push({
            id: String(survey.id), kind: '설문지', name: String(survey.name || survey.id),
            version: String(this.connectionItemVersion(survey)), status: '적용 중'
        });
        await this.persistHarnessBindings(bindings, String(survey.id), survey.name + ' 설문지를 연결했습니다.');
    }

    public latestRun() {
        const latest = this.testRuns()[0];
        if (latest) return latest;
        return {
            id: '시험 이력 없음',
            date: '—',
            version: String(this.harness?.version || '—'),
            dataset: '미연결',
            survey: '미연결',
            coverage: '0 / 0',
            coverageContext: '',
            result: '대기',
            status: '실행 대기'
        };
    }

    public nextActionDescription() {
        const label = this.readinessLabel();
        if (label === 'AI 품질 통과') return '위임형 AI 품질 게이트는 통과했지만 운영 승인은 아직 대기 중입니다.';
        if (label === '운영 가능') return '현재 버전이 적용된 프로젝트와 최근 시험 결과를 확인합니다.';
        if (label === '검증 필요') return '현재 연결된 데이터셋과 설문지로 남은 시험을 완료합니다.';
        return '데이터셋과 설문지 연결을 확인한 뒤 첫 시험을 시작합니다.';
    }

    public readinessSteps() {
        if (!this.harness) return [];
        const passRate = Number(this.harness.passRate) || 0;
        const projects = this.currentProjectCount();
        const releasePending = this.harness.humanReleaseStatus === 'pending';
        return [
            { no: 1, label: '규칙 구성', description: '평가 규칙과 판정 기준을 구성했습니다.', state: 'done' },
            { no: 2, label: '시험 실행', description: '대표 데이터셋으로 성능을 검증합니다.', state: passRate > 0 ? 'done' : 'current' },
            { no: 3, label: '성능 판정', description: '목표 통과율과 오류율을 확인합니다.', state: passRate >= 90 ? 'done' : (passRate > 0 ? 'current' : 'pending') },
            {
                no: 4,
                label: releasePending ? '운영 승인' : '프로젝트 적용',
                description: releasePending
                    ? '담당 검수자가 운영 사용 여부를 별도로 승인해야 합니다.'
                    : '검증된 버전을 프로젝트에 연결합니다.',
                state: releasePending ? 'current' : (projects > 0 ? 'done' : (passRate >= 90 ? 'current' : 'pending'))
            }
        ];
    }

    public testCoverage() {
        if (!this.harness) return 0;
        if (this.workspaceStateLoaded) {
            const latest = this.latestTestHistory();
            const coverage = this.numericValue(latest?.coverage);
            if (coverage !== null) return coverage;
            return 0;
        }
        const passRate = Number(this.harness.passRate) || 0;
        if (passRate >= 90) return 24;
        if (passRate > 0) return 18;
        return 6;
    }

    public testTotal() {
        if (!this.harness) return 0;
        if (this.workspaceStateLoaded) {
            const latest = this.latestTestHistory();
            return this.numericValue(latest?.total, latest?.coverage) || 0;
        }
        return 24;
    }

    public failureCount() {
        if (this.workspaceStateLoaded) {
            const latest = this.latestTestHistory();
            const failures = this.numericValue(latest?.failed, latest?.failureCount, latest?.failure_count);
            if (failures !== null) return failures;
            if (latest?.runPassed === true) return 0;
            if (Array.isArray(latest?.failures)) return latest.failures.length;
            return 0;
        }
        return 24 - this.testCoverage();
    }

    public passFailureLabel(row: any) {
        const passed = this.numericValue(row?.passed);
        const failed = this.numericValue(row?.failed);
        if (passed !== null || failed !== null) return `${passed || 0} / ${failed || 0}`;
        if (row?.runPassed === true) return '종합 통과';
        if (row?.runPassed === false) return '종합 미달';
        return '집계 없음';
    }

    public recommendation() {
        const label = this.readinessLabel();
        if (label === 'AI 품질 통과') return '운영 승인 전까지 적용을 보류하고 AI 검수 근거를 확인하세요.';
        if (label === '운영 가능') return '운영 적용 전 프로젝트별 기준값을 마지막으로 확인하세요.';
        if (label === '검증 필요') return '남은 시험을 실행하고 성능 판정을 완료하세요.';
        return '규칙 구성을 마친 뒤 첫 시험을 실행하세요.';
    }

    public versions() {
        if (!this.harness || !Array.isArray(this.harness.versions)) return [];
        return this.harness.versions;
    }

    public selectedBaseVersion() {
        return this.versions().find((version: any) => version.version === this.baseVersionId) || null;
    }

    public selectedCompareVersion() {
        return this.versions().find((version: any) => version.version === this.compareVersionId) || null;
    }

    public canCompareVersions() {
        return Boolean(this.selectedBaseVersion() && this.selectedCompareVersion() && this.baseVersionId !== this.compareVersionId);
    }

    public async toggleSameConditionOnly() {
        this.sameConditionOnly = !this.sameConditionOnly;
        await this.service.render();
    }

    public async swapComparedVersions() {
        const previousBase = this.baseVersionId;
        this.baseVersionId = this.compareVersionId;
        this.compareVersionId = previousBase;
        await this.service.render();
    }

    public async toggleVersionSelector(kind: string) {
        this.openVersionSelector = this.openVersionSelector === kind ? '' : kind;
        await this.service.render();
    }

    public async selectVersionForComparison(kind: string, version: string) {
        if (kind === 'base') this.baseVersionId = version;
        else this.compareVersionId = version;
        this.openVersionSelector = '';
        await this.service.render();
    }

    public async closeVersionSelector(event: any) {
        const relatedTarget = event && event.relatedTarget;
        const currentTarget = event && event.currentTarget;
        if (relatedTarget && currentTarget && currentTarget.contains(relatedTarget)) return;
        if (!this.openVersionSelector) return;
        this.openVersionSelector = '';
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    public async closeVersionSelectorFromOutside(event: MouseEvent) {
        if (!this.openVersionSelector) return;
        const target = event.target as HTMLElement | null;
        if (target && target.closest('.harness-version-selector')) return;
        this.openVersionSelector = '';
        await this.service.render();
    }

    private versionTestRun(version: any) {
        if (!version) return null;
        return this.historyRows().find((row: any) =>
            row.type === '시험 실행' && String(row.harnessVersion) === String(version.version)
        ) || null;
    }

    private versionProjectCount(version: any) {
        if (!version) return 0;
        const versionId = String(version.version || '');
        return this.currentProjectBindings().filter((project: any) =>
            !project.empty && String(project.version || '') === versionId
        ).length;
    }

    public versionSnapshot(version: any) {
        if (!version) return null;
        const testRow = this.versionTestRun(version);
        const total = this.numericValue(testRow?.total, testRow?.coverage) || 0;
        const passed = this.numericValue(testRow?.passed);
        const failed = this.numericValue(testRow?.failed);
        return {
            score: this.numericValue(testRow?.score, version?.passRate) || 0,
            datasetName: testRow?.datasetName || '—',
            datasetId: testRow?.datasetId || '-',
            datasetVersion: testRow?.datasetVersion || '—',
            surveyName: testRow?.surveyName || '—',
            surveyId: testRow?.surveyId || '-',
            surveyVersion: testRow?.surveyVersion || '—',
            threshold: this.numericValue(testRow?.threshold, this.harness?.target) || 0,
            testItems: total,
            passed: passed !== null ? passed : (testRow?.runPassed === true ? total : 0),
            failed: failed !== null ? failed : (passed !== null ? Math.max(0, total - passed) : 0),
            qaCount: this.numericValue(testRow?.qaCount, testRow?.qa_count) || 0,
            claimCount: this.numericValue(testRow?.claimCount, testRow?.claim_count) || 0,
            dimensionScores: Array.isArray(testRow?.dimensionScores) ? testRow.dimensionScores : [],
            failures: this.versionFailuresFromRun(testRow),
            recentRun: testRow ? testRow.id : '-',
            recentDate: testRow ? testRow.date : '-',
            projects: this.versionProjectCount(version)
        };
    }

    private versionPassCount(version: any) {
        return this.numericValue(this.versionSnapshot(version)?.passed) || 0;
    }

    private comparisonDelta(baseValue: number, compareValue: number, unit: string = '') {
        const delta = Math.round((compareValue - baseValue) * 100) / 100;
        if (delta > 0) return '+' + delta + unit;
        if (delta < 0) return String(delta) + unit;
        return '변화 없음';
    }

    private failureDelta(baseValue: number, compareValue: number) {
        const delta = compareValue - baseValue;
        if (delta < 0) return Math.abs(delta) + '개 감소';
        if (delta > 0) return '+' + delta + '개 증가';
        return '변화 없음';
    }

    public versionComparisonMetrics() {
        const base = this.selectedBaseVersion();
        const compare = this.selectedCompareVersion();
        if (!base || !compare) return [];
        const baseSnapshot = this.versionSnapshot(base);
        const compareSnapshot = this.versionSnapshot(compare);
        const baseScore = Number(baseSnapshot.score) || 0;
        const compareScore = Number(compareSnapshot.score) || 0;
        const basePass = this.versionPassCount(base);
        const comparePass = this.versionPassCount(compare);
        const baseTotal = Number(baseSnapshot.testItems) || 0;
        const compareTotal = Number(compareSnapshot.testItems) || 0;
        const baseFailed = Number(baseSnapshot.failed) || 0;
        const compareFailed = Number(compareSnapshot.failed) || 0;
        const baseRules = Array.isArray(base.rules) ? base.rules.length : 0;
        const compareRules = Array.isArray(compare.rules) ? compare.rules.length : 0;
        const baseProjects = Number(baseSnapshot.projects) || 0;
        const compareProjects = Number(compareSnapshot.projects) || 0;
        return [
            { label: '종합 점수', base: baseScore + '점', compare: compareScore + '점', delta: this.comparisonDelta(baseScore, compareScore, '점'), improved: compareScore >= baseScore },
            { label: '통과 항목', base: basePass + ' / ' + baseTotal, compare: comparePass + ' / ' + compareTotal, delta: this.comparisonDelta(basePass, comparePass, '개'), improved: comparePass >= basePass },
            { label: '실패 항목', base: baseFailed + '개', compare: compareFailed + '개', delta: this.failureDelta(baseFailed, compareFailed), improved: compareFailed <= baseFailed },
            { label: '평가 규칙', base: baseRules + '개', compare: compareRules + '개', delta: this.comparisonDelta(baseRules, compareRules, '개'), improved: compareRules >= baseRules },
            { label: 'QA 생성물', base: baseSnapshot.qaCount + '개', compare: compareSnapshot.qaCount + '개', delta: this.comparisonDelta(baseSnapshot.qaCount, compareSnapshot.qaCount, '개'), improved: compareSnapshot.qaCount >= baseSnapshot.qaCount },
            { label: 'KG Claim', base: baseSnapshot.claimCount + '개', compare: compareSnapshot.claimCount + '개', delta: this.comparisonDelta(baseSnapshot.claimCount, compareSnapshot.claimCount, '개'), improved: compareSnapshot.claimCount >= baseSnapshot.claimCount },
            { label: '적용 프로젝트', base: baseProjects + '개', compare: compareProjects + '개', delta: this.comparisonDelta(baseProjects, compareProjects, '개'), improved: compareProjects >= baseProjects }
        ];
    }

    public versionRuleChanges() {
        const base = this.selectedBaseVersion();
        const compare = this.selectedCompareVersion();
        if (!base || !compare) return { added: [], modified: [], removed: [] };
        const baseRules = (Array.isArray(base.rules) ? base.rules : [])
            .map((rule: any) => String(rule).trim()).filter(Boolean);
        const compareRules = (Array.isArray(compare.rules) ? compare.rules : [])
            .map((rule: any) => String(rule).trim()).filter(Boolean);
        const baseSet = new Set(baseRules);
        const compareSet = new Set(compareRules);
        return {
            added: compareRules.filter((rule: string) => !baseSet.has(rule)),
            modified: [],
            removed: baseRules.filter((rule: string) => !compareSet.has(rule))
        };
    }

    public visibleVersionRuleChanges(group: 'added' | 'modified' | 'removed') {
        const items = this.versionRuleChanges()[group];
        return this.expandedRuleChangeGroups[group] ? items : items.slice(0, 6);
    }

    public hiddenVersionRuleChangeCount(group: 'added' | 'modified' | 'removed') {
        return Math.max(0, this.versionRuleChanges()[group].length - 6);
    }

    public async toggleVersionRuleChanges(group: 'added' | 'modified' | 'removed') {
        this.expandedRuleChangeGroups[group] = !this.expandedRuleChangeGroups[group];
        await this.service.render();
    }

    private versionResourceLabel(name: string, version: string) {
        const parts = [name, version]
            .map((value: any) => String(value || '').trim())
            .filter((value: string) => value && value !== '—' && value !== '-');
        return parts.length ? parts.join(' · ') : '실행 기록 없음';
    }

    public versionConditionRows() {
        const base = this.versionSnapshot(this.selectedBaseVersion());
        const compare = this.versionSnapshot(this.selectedCompareVersion());
        if (!base || !compare) return [];
        return [
            { label: '데이터셋', base: this.versionResourceLabel(base.datasetName, base.datasetVersion), compare: this.versionResourceLabel(compare.datasetName, compare.datasetVersion), same: base.datasetId === compare.datasetId && base.datasetVersion === compare.datasetVersion },
            { label: '설문지', base: this.versionResourceLabel(base.surveyName, base.surveyVersion), compare: this.versionResourceLabel(compare.surveyName, compare.surveyVersion), same: base.surveyId === compare.surveyId && base.surveyVersion === compare.surveyVersion },
            { label: '통과 기준', base: base.threshold + '점', compare: compare.threshold + '점', same: base.threshold === compare.threshold },
            { label: '시험 항목', base: base.testItems + '개', compare: compare.testItems + '개', same: base.testItems === compare.testItems },
            { label: 'QA 생성물', base: base.qaCount + '개', compare: compare.qaCount + '개', same: base.qaCount === compare.qaCount },
            { label: 'KG Claim', base: base.claimCount + '개', compare: compare.claimCount + '개', same: base.claimCount === compare.claimCount },
            { label: '최근 실행', base: base.recentRun, compare: compare.recentRun, same: base.recentRun === compare.recentRun }
        ];
    }

    public versionConditionsDiffer() {
        return this.versionConditionRows().some((row: any) => !row.same && row.label !== '최근 실행');
    }

    public versionMetricComparisons() {
        const baseSnapshot = this.versionSnapshot(this.selectedBaseVersion());
        const compareSnapshot = this.versionSnapshot(this.selectedCompareVersion());
        if (!baseSnapshot || !compareSnapshot) return [];
        const baseScores = this.dimensionScoreMap(baseSnapshot.dimensionScores);
        const compareScores = this.dimensionScoreMap(compareSnapshot.dimensionScores);
        const keys = Array.from(new Set([...baseScores.keys(), ...compareScores.keys()]));
        return keys.map((key: string) => {
            const baseMetric = baseScores.get(key);
            const compareMetric = compareScores.get(key);
            const baseScore = baseMetric?.score ?? null;
            const compareScore = compareMetric?.score ?? null;
            return {
                label: compareMetric?.label || baseMetric?.label || key,
                base: baseScore,
                compare: compareScore,
                baseWidth: baseScore ?? 0,
                compareWidth: compareScore ?? 0,
                baseLabel: baseScore === null ? '—' : baseScore + '점',
                compareLabel: compareScore === null ? '—' : compareScore + '점',
                delta: baseScore === null || compareScore === null
                    ? '비교 불가'
                    : this.comparisonDelta(baseScore, compareScore, '점')
            };
        });
    }

    private dimensionScoreMap(rows: any[]) {
        const scores = new Map<string, any>();
        (Array.isArray(rows) ? rows : []).forEach((row: any, index: number) => {
            const key = String(row?.key || row?.id || row?.label || `dimension-${index}`);
            const score = this.numericValue(row?.score, row?.value);
            if (score === null) return;
            scores.set(key, { label: row?.label || row?.name || key, score });
        });
        return scores;
    }

    private versionFailuresFromRun(run: any) {
        if (!run) return [];
        const failures = Array.isArray(run.failures) ? run.failures : [];
        const issues = Array.isArray(run.issues) ? run.issues : [];
        return Array.from(new Set(failures.concat(issues).map((item: any) => String(item).trim()).filter(Boolean)));
    }

    public versionFailureChanges() {
        const base = this.versionSnapshot(this.selectedBaseVersion());
        const compare = this.versionSnapshot(this.selectedCompareVersion());
        if (!base || !compare) return { resolved: [], remaining: [], newItems: [] };
        const baseFailures = base.failures;
        const compareFailures = compare.failures;
        const baseSet = new Set(baseFailures);
        const compareSet = new Set(compareFailures);
        return {
            resolved: baseFailures.filter((item: string) => !compareSet.has(item)),
            remaining: baseFailures.filter((item: string) => compareSet.has(item)),
            newItems: compareFailures.filter((item: string) => !baseSet.has(item))
        };
    }

    public async openComparisonHistory() {
        this.tab = 'tests';
        await this.service.render();
    }

    public async rerunVersionComparison() {
        if (this.readOnlyMode) return;
        const compare = this.selectedCompareVersion();
        if (!compare) return;
        await this.service.modal.success(compare.version + ' 버전의 새 시험을 준비했습니다.');
        await this.service.render();
    }

    public async copyVersionSettings() {
        if (this.readOnlyMode) return;
        const compare = this.selectedCompareVersion();
        if (!compare) return;
        await this.service.modal.success(compare.version + ' 설정을 새 버전 초안으로 복사할 준비를 마쳤습니다.');
        await this.service.render();
    }

    private serverHistoryRows() {
        if (!this.workspaceStateLoaded || !this.harness) return [];
        const rawRows = Array.isArray(this.harness.testRuns)
            ? this.harness.testRuns
            : (Array.isArray(this.harness.history) ? this.harness.history : []);
        const boundSurvey = this.serverBindings().find((binding: any) => binding.kind === '설문지') || {};
        return rawRows.map((row: any, index: number) => {
            const score = this.numericValue(row?.score, row?.passRate, row?.pass_rate, row?.totalScore, row?.total_score) || 0;
            const qaCount = this.numericValue(row?.qaCount, row?.qa_count) || 0;
            const claimCount = this.numericValue(row?.claimCount, row?.claim_count) || 0;
            const derivedTotal = qaCount + claimCount;
            const explicitCoverage = this.numericValue(row?.coverage, row?.covered, row?.reviewedCount, row?.reviewed_count);
            const total = this.numericValue(row?.total, row?.testItems, row?.test_items, row?.coverageTotal, row?.coverage_total)
                ?? (derivedTotal > 0 ? derivedTotal : (explicitCoverage || 0));
            const coverage = explicitCoverage ?? (total > 0 ? total : 0);
            const runPassed = typeof row?.runPassed === 'boolean'
                ? row.runPassed
                : (typeof row?.passed === 'boolean'
                    ? row.passed
                    : (typeof row?.passedRun === 'boolean' ? row.passedRun : (typeof row?.passed_run === 'boolean' ? row.passed_run : null)));
            const passed = typeof row?.passed === 'boolean'
                ? null
                : this.numericValue(row?.passed, row?.passCount, row?.pass_count);
            const failed = this.numericValue(row?.failed, row?.failureCount, row?.failure_count);
            const typeValue = String(row?.type || row?.kind || '').toLowerCase();
            const type = typeValue.indexOf('apply') >= 0 || typeValue.indexOf('project') >= 0 || typeValue.indexOf('적용') >= 0
                ? '프로젝트 적용'
                : '시험 실행';
            const version = row?.harnessVersion || row?.harness_version || row?.version || this.harness.version;
            const datasetName = row?.datasetName || row?.dataset_name
                || (typeof row?.dataset === 'string' ? row.dataset : row?.dataset?.name)
                || '연결 데이터셋';
            const datasetVersion = row?.datasetVersion || row?.dataset_version || row?.dataset?.version || version || '현재';
            const surveyName = row?.surveyName || row?.survey_name || row?.survey?.name || boundSurvey.name || '연결 설문지';
            const surveyVersion = row?.surveyVersion || row?.survey_version || row?.survey?.version || boundSurvey.version || '현재';
            const taskCount = this.numericValue(row?.taskCount, row?.task_count);
            const sampleCount = this.numericValue(row?.sampleCount, row?.sample_count);
            return {
                ...row,
                id: String(row?.id || `RUN-${this.harness.id}-${String(index + 1).padStart(3, '0')}`),
                type,
                date: row?.date || row?.createdAt || row?.created_at || '—',
                actor: row?.actor || row?.author || row?.reviewer || this.harness.owner,
                harnessVersion: version,
                datasetName,
                datasetId: row?.datasetId || row?.dataset_id || row?.dataset?.id || '-',
                datasetVersion,
                datasetKey: row?.datasetKey || row?.dataset_key || `${datasetName} ${datasetVersion}`,
                surveyName,
                surveyId: row?.surveyId || row?.survey_id || row?.survey?.id || boundSurvey.id || '-',
                surveyVersion,
                surveyKey: row?.surveyKey || row?.survey_key || `${surveyName} ${surveyVersion}`,
                project: row?.projectName || row?.project_name || row?.project?.name || row?.project || '시험 적용',
                score,
                scoreLabel: row?.scoreLabel || row?.score_label || (score > 0 ? `${score}점` : '대기'),
                threshold: this.numericValue(row?.threshold, row?.target, this.harness?.threshold, this.harness?.target) || 90,
                coverage,
                total,
                taskCount,
                sampleCount,
                passed,
                failed,
                runPassed,
                duration: row?.duration || '—',
                status: row?.status || (runPassed === true || score >= this.passThreshold() ? '통과' : (runPassed === false || score > 0 ? '검증 필요' : '실행 대기')),
                dimensionScores: Array.isArray(row?.dimensionScores)
                    ? row.dimensionScores
                    : (Array.isArray(row?.dimension_scores) ? row.dimension_scores : []),
                failures: Array.isArray(row?.failures)
                    ? row.failures
                    : (Array.isArray(row?.issues) ? row.issues : [])
            };
        }).sort((a: any, b: any) => String(b.date).localeCompare(String(a.date)));
    }

    public historyRows() {
        if (!this.harness) return [];
        if (this.workspaceStateLoaded) return this.serverHistoryRows();
        const dataset = this.currentDataset();
        const survey = this.currentSurvey();
        const projects = this.currentProjectBindings().filter((project: any) => !project.empty);
        const versions = this.versions().length ? this.versions() : [this.currentVersionData()];

        const testRows = versions.map((version: any, index: number) => {
            const score = Number(version.passRate) || 0;
            const coverage = score >= 90 ? 24 : (score > 0 ? 18 : 6);
            const isCurrent = String(version.version) === String(this.harness.version);
            const datasetVersion = isCurrent
                ? dataset.version
                : (dataset.version === 'v2.0' ? 'v1.0' : dataset.version);
            const surveyVersion = isCurrent ? survey.version : survey.version;
            const project = isCurrent && projects.length ? projects[0].name : '시험 적용';
            const runNo = String(versions.length - index).padStart(3, '0');
            return {
                id: 'RUN-' + this.harness.id + '-' + runNo,
                type: '시험 실행',
                date: version.date + (index === 0 ? ' 10:21' : ' 15:40'),
                actor: version.author || this.harness.owner,
                harnessVersion: version.version,
                datasetName: dataset.name,
                datasetId: dataset.id,
                datasetVersion,
                datasetKey: dataset.name + ' ' + datasetVersion,
                surveyName: survey.name,
                surveyId: survey.id,
                surveyVersion,
                surveyKey: survey.name + ' ' + surveyVersion,
                project,
                score,
                scoreLabel: score > 0 ? score + '점' : '대기',
                threshold: this.passThreshold(),
                coverage,
                passed: Math.min(coverage, Math.round(coverage * score / 100)),
                failed: 24 - coverage,
                duration: index === 0 ? '12분 18초' : '14분 06초',
                status: score >= this.passThreshold() ? '통과' : (score > 0 ? '검증 필요' : '실행 대기'),
                dimensionScores: [
                    { label: '사실 정확성', score: score ? Math.min(100, score + 2) : 0 },
                    { label: '원문 근거', score: score ? Math.max(0, score - 3) : 0 },
                    { label: '맥락 일치성', score: score ? Math.min(100, score + 1) : 0 },
                    { label: '형식 준수', score: score ? Math.min(100, score + 4) : 0 }
                ],
                failures: score >= this.passThreshold()
                    ? ['원문 인용 위치 1건을 추가 확인했습니다.']
                    : ['원문 근거 연결이 부족한 항목이 있습니다.', '시대 맥락 판정 기준을 다시 확인해야 합니다.']
            };
        });

        const applicationRows = projects.map((project: any, index: number) => ({
            id: 'APPLY-' + this.harness.id + '-' + String(index + 1).padStart(3, '0'),
            type: '프로젝트 적용',
            date: this.harness.updated + ' ' + (index === 0 ? '14:30' : '16:10'),
            actor: this.harness.owner,
            harnessVersion: this.harness.version,
            datasetName: dataset.name,
            datasetId: dataset.id,
            datasetVersion: dataset.version,
            datasetKey: dataset.name + ' ' + dataset.version,
            surveyName: survey.name,
            surveyId: survey.id,
            surveyVersion: survey.version,
            surveyKey: survey.name + ' ' + survey.version,
            project: project.name,
            score: Number(this.harness.passRate) || 0,
            scoreLabel: (Number(this.harness.passRate) || 0) + '점',
            threshold: this.passThreshold(),
            coverage: this.testCoverage(),
            passed: this.testCoverage(),
            failed: this.failureCount(),
            duration: '-',
            status: project.status,
            dimensionScores: [],
            failures: []
        }));

        return testRows.concat(applicationRows).sort((a: any, b: any) => String(b.date).localeCompare(String(a.date)));
    }

    public totalTestHistoryCount() {
        return this.historyRows().filter((row: any) => row.type === '시험 실행').length;
    }

    public appliedProjectHistoryCount() {
        return this.currentProjectBindings().filter((project: any) => !project.empty).length;
    }

    public latestTestHistory() {
        return this.historyRows().find((row: any) => row.type === '시험 실행');
    }

    public async toggleHistoryRow(row: any) {
        this.expandedHistoryId = this.expandedHistoryId === row.id ? '' : row.id;
        await this.service.render();
    }

    public historyStatusClass(status: string) {
        if (status === '통과' || status === '운영 적용') return 'is-pass';
        if (status === '검증 필요' || status === '검증 적용') return 'is-review';
        return 'is-waiting';
    }

    public async openHistoryResource(kind: string) {
        await this.router.navigate(kind === 'survey' ? ['/surveys'] : ['/review-projects']);
    }

    public async rerunHistory(row: any) {
        if (this.readOnlyMode) return;
        await this.service.modal.success(row.harnessVersion + '의 동일 조건 시험을 준비했습니다.');
        await this.service.render();
    }

    public testRuns() {
        const latest = this.latestTestHistory();
        if (!latest) return [];
        return [{
            id: latest.id,
            date: latest.date,
            version: latest.harnessVersion,
            dataset: latest.datasetKey,
            survey: latest.surveyKey,
            coverage: latest.coverage + ' / ' + latest.total,
            taskCount: latest.taskCount,
            sampleCount: latest.sampleCount,
            coverageContext: latest.taskCount !== null && latest.sampleCount !== null
                ? latest.taskCount + '개 task · ' + latest.sampleCount + '개 의미 표본'
                : '',
            result: latest.scoreLabel,
            status: latest.status
        }];
    }

}

export default PageHarnessesItemComponent;